<template>
  <div class="admin-tests-modify-container">

    <!-- Loading Spinner -->
    <div v-if="loading || modalLoading" class="loading-overlay">
      <div class="spinner"></div>
    </div>

    <Navigation
      v-bind:Breadcrumb="[
        { name: 'Home', route: 'Home' },
        { name: 'Staff', route: 'Admin' },
        { name: 'View Tests', route: 'Admin_Tests' },
        { name: 'Update Test Details', route: 'Admin_Tests' },
      ]"
    />
    <div class="placeholder content-wrapper">
      <Admin_Tests_Header :test-id="$route.params.id" :business-name="form.business_name" :uuid="form.uuid" />
      <div class="row">
        <div class="col-5">
          <div class="error" v-for="error in errMsg" :key="error">
            {{ error }}
          </div>
          <div class="success" v-for="message in msg" :key="message">
            {{ message }}
          </div>
          <form class="form" v-on:submit.prevent>
            <FormSection title="Test information">
              <label for="form.cow_id">Sample ID</label>
              <input type="text" v-model="form.cow_id" class="input" required />

              <label for="form.farmer_name">Client Name</label>
              <input type="text" v-model="form.farmer_name" class="input" />


              <label for="form.animaltype">Animal Type</label>
              <select 
                v-if="form.test_type != 4"
                name="form.animaltype"
                id="form.animaltype"
                class="input"
                v-model.number="form.animaltype"
                required
              >
                <option value="1">Bovine</option>
                <option value="2">Ovine</option>
                <option value="3">Equine</option>
                <option value="4">Caprine</option>
                <option value="7">Poultry</option>
                <option value="8">Alpaca</option>
                <option value="9">Llama</option>
              </select>

              <select 
                v-if="form.test_type == 4"
                name="form.animaltype"
                id="form.animaltype"
                class="input"
                v-model.number="form.animaltype"
                required
              >
                <option value="5">Canine</option>
                <option value="6">Feline</option>              
              </select>

              <label for="form.sampletype">Sample Type</label>
              <select
                name="form.sampletype"
                id="form.sampletype"
                class="input"
                v-model.number="form.sampletype"
                required
              >
                <option value="1">Individual</option>
                <option value="2">Pooled</option>
              </select>

              <label for="form.status">Status</label>
              <select
                name="form.status"
                id="form.status"
                class="input"
                v-model="form.status"
                required
              >
                <option value="green">Negative - Green</option>
                <option value="red">Positive - Red</option>
                <option value="process">PROCESS - Processing Test</option>
                <option value="failed">Repeat Required</option>
              </select>

              <div v-if="form.status === 'failed'">
                <label for="form.failreasons_drop"
                  >Select a Failure Reason Template.</label
                >
                <select
                  v-on:change="this.setFailReason()"
                  name="form.failreasons_drop"
                  id="form.failreasons_drop"
                  class="input"
                  v-model="form.failreasons_drop"
                >
                  <option
                    v-for="(row, index) in failreasons"
                    :key="index"
                    :value="row"
                  >
                    {{ row }}
                  </option>
                </select>
                <label for="form.failreason">Reason for Failure</label>
                <textarea class="input" rows="5" v-model="form.failreason">
                </textarea>
              </div>

              <label for="form.created_at">Created</label>
              <input
                type="datetime-local"
                v-model="form.created_at"
                class="input"
                step="1"
                required
              />

              <label for="form.bucket_file">Bucket File</label>
              <input
                type="text"
                v-model="form.bucket_file"
                class="input"
                readonly
              />
              <label for="form.bucket_file">Test Performed By</label>
              <input
                type="text"
                v-model="form.tester_name"
                class="input"
                readonly
              />            
              <label for="form.original_file">Original File</label>
              <input
                type="text"
                v-model="form.original_file"
                class="input"
                readonly
              />
              <label for="form.request_id">ML Request ID</label>
              <input
                type="number"
                v-model="form.request_id"
                class="input"
                readonly
              />
              <label for="form.notes">Notes / Symptoms</label>
              <textarea
                type="number"
                v-model="form.notes"
                class="input"
                readonly
              />
            </FormSection>

            <FormSection title="Videos">
              <label>Detected Video File</label>
              <Admin_Tests_VideoViewer
                v-if="this.form.detected_bucket_file !== null"
                :options="this.playerOptions_dect"
              />
              <br />
              <br />
              <label>Original File</label>
              <Admin_Tests_VideoViewer
                v-if="this.form.bucket_file !== null"
                :options="this.playerOptions"
              />
              <br />
              <br />
              <Admin_Tests_WhiteBalance :test-id="$route.params.id" />
            </FormSection>

            <FormSection title="Downloads">
              <button
                v-if="
                  this.form.detected_bucket_file !== null ||
                  this.form.detected_bucket_file !== ''
                "
                style="margin-right: 10px"
                class="btn btn-orange"
                value="Download Detected Video"
                v-on:click="
                  DownloadVideo(
                    'https://detected-videos.s3.eu-west-1.amazonaws.com',
                    this.form.detected_bucket_file
                  )
                "
              >
                Download Detected Video
              </button>
              <button
                v-if="
                  this.form.detected_bucket_file !== null ||
                  this.form.detected_bucket_file !== ''
                "
                style="margin-right: 10px"
                class="btn btn-orange"
                value="Download Detected Video"
                v-on:click="
                  DownloadVideo(
                    'https://bpi-sa-preprod.s3.eu-west-1.amazonaws.com',
                    this.form.bucket_file
                  )
                "
              >
                Download Bucket Video
              </button>
            </FormSection>
          </form>
        </div>
        <div class="col-7">
          <FormSection title="Test results">
            <form class="form">
              <label>
                <span 
                  v-if="form.special_attention" 
                  style="
                    display: inline-block;
                    margin-left: 6px;
                    background: #fbbf24;
                    color: #78350f;
                    padding: 2px 6px;
                    border-radius: 8px;
                    font-size: 10px;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.3px;
                    white-space: nowrap;
                  "
                  title="This business requires special attention during the review process."
                >
                  ⚠ Special Attention
                </span>
                <Admin_Tests_DoubleCheckBadge v-if="form.double_check_required === true" />
                <span 
                  v-if="form.larvae_required && form.test_type != 3 && form.test_type != 4"
                  class="larvae-badge"
                  title="This test requires larvae analysis - check the Larvae row below."
                >
                  🔬 Larvae Analysis
                </span>
              </label>
            </form>
          <div class="table-flag-group">
          <div :class="{ 'special-attention-frame': form.special_attention }">
          <table :class="{ 'double-check': form.double_check_required === true }">
            <thead>
              <tr>
                <th>Pest</th>
                <th>Reviewer input</th>
                <th>Manual Count</th>
                <th>ML Count</th>
                <th>Status</th>
                <th>Time of Result</th>
                <th>Reviewer flag</th>
                
              </tr>
            </thead>

            <!-- Bovine & Ovine & Caprine & WORM FEC -->
            <tbody v-if="(form.animaltype ==1 || form.animaltype ==2 || form.animaltype ==4) && form.test_type!=3 && form.test_type!=4">
              <tr>
                <td 
                  id = "pestForm.Type">
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Coccidia'" @mouseleave="handleMouseLeave">
                    Coccidia
                  </div>
                </td>
                <td> 
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Coccidia'" @mouseleave="handleMouseLeave">
                    <input
                      id = "Coccidia_input"
                      type = "number"
                      class="input"
                      v-model="pestForm.Count_Coccidia"
                      :disabled="isChecked_present_uncounted"
                      min="0"
                      step="30"
                      placeholder="-" >
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Coccidia'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Coccidia'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Coccidia' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Coccidia' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Coccidia'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td colspan="1">
                  <label class="reviewer-flag-option">
                    <input type="checkbox" v-model="isChecked_inconclusive" :disabled="isChecked_present_uncounted" @change="handleCheckboxinconclusive"/>
                    Invalid
                  </label>
                  <label class="reviewer-flag-option">
                    <input type="checkbox" v-model="isChecked_present_uncounted" :disabled="isChecked_inconclusive" @change="handleCheckboxPresentUncounted"/>
                    Present (uncounted)
                  </label>
                </td>

              </tr>
              <tr>
                <td id = "pestForm.Type">
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Strongyle'" @mouseleave="handleMouseLeave">
                    Strongyle
                  </div>
                </td>
                <td> 
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Moniezia'" @mouseleave="handleMouseLeave">
                    <input 
                      id = "Strongyle_input" 
                      type = "number" 
                      class="input" 
                      v-model="pestForm.Count_Strongyle" 
                      min="0" 
                      step="30" 
                      placeholder="-" 
                      @focus="activeTooltip = 'Strongyle'"
                      @blur="handleBlur"
                    >
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyle'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyle'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Strongyle' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Strongyle' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Strongyle'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
               
              </tr>

              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'NemaBattus' }"                
              >
                <td>                  
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'NemaBattus'" @mouseleave="handleMouseLeave">
                    Nematodirus battus
                    <div class="egg-tooltip-content">
                      <img src="@/assets/parasites/NemaBattus.png" class="egg-thumbnail" />
                    </div>
                  </div>
                </td>
                <td>
                  <input
                    id="Nematodirus_battus_input"
                    type="number"
                    class="input"
                    v-model="pestForm.Count_Nematodirus_Battus"
                    min="0"
                    step="30"
                    placeholder="-"
                    @focus="activeTooltip = 'NemaBattus'"                    
                    @blur="handleBlur"
                  />
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Nematodirus battus'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Nematodirus battus'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Nematodirus battus' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Nematodirus battus' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Nematodirus battus'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>           

              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'NemaSpp' }"                
              >
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'NemaSpp'" @mouseleave="handleMouseLeave">
                    Nematodirus spp
                    <div class="egg-tooltip-content">
                      <img src="@/assets/parasites/NemaSpp.png" class="egg-thumbnail" />
                    </div>
                  </div>
                </td>
                <td>
                  <input
                    id="Nematodirus_spp_input"
                    type="number"
                    class="input"
                    v-model="pestForm.Count_Nematodirus_Spp"
                    min="0"
                    step="30"
                    placeholder="-"
                    @focus="activeTooltip = 'NemaSpp'"
                    @blur="handleBlur"
                  />
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Nematodirus'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Nematodirus'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Nematodirus' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Nematodirus' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Nematodirus'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>        

              <tr>
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Strongyloides'" @mouseleave="handleMouseLeave">
                    Strongyloides
                  </div>
                </td>
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Strongyloides'" @mouseleave="handleMouseLeave">
                    <input 
                      id = "Strongyloides_input" 
                      type = "number" 
                      class="input" 
                      v-model="pestForm.Count_Strongyloides" 
                      min="0" 
                      step="30" 
                      placeholder="-" 
                      @focus="activeTooltip = 'Strongyloides'"
                      @blur="handleBlur"
                    >
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyloides'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyloides'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Strongyloides' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Strongyloides' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Strongyloides'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td colspan="1">
                  <label class="reviewer-flag-option">
                    <input type="checkbox" v-model="isChecked_inconclusive_strongyloides" @change="handleCheckboxinconclusive"/>
                    Invalid
                  </label>
                </td>

              </tr>                                                 
              <tr>
                <td 
                  id = "pestForm.Type">
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Moniezia'" @mouseleave="handleMouseLeave">
                    Moniezia
                  </div>                  
                </td>
                <td> 
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Moniezia'" @mouseleave="handleMouseLeave">
                    <input 
                      id = "Moniezia_input" 
                      type = "number" 
                      class="input" 
                      v-model="pestForm.Count_Moniezia" 
                      min="0" 
                      step="30" 
                      placeholder="-" 
                      @focus="activeTooltip = 'Moniezia'"
                      @blur="handleBlur"
                    >
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Moniezia'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Moniezia'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Moniezia' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Moniezia' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Moniezia'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>

              </tr> 
              <tr>
                <td id = "pestForm.Type">
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Trichuris'" @mouseleave="handleMouseLeave">
                    Trichuris
                  </div>
                </td>
                <td> 
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Trichuris'" @mouseleave="handleMouseLeave">
                    <input 
                      id = "Trichuris_input" 
                      type = "number" 
                      class="input" 
                      v-model="pestForm.Count_Trichuris" 
                      min="0" 
                      step="30" 
                      placeholder="-" 
                      @focus="activeTooltip = 'Trichuris'"
                      @blur="handleBlur"
                    >
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Trichuris'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Trichuris'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Trichuris' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Trichuris' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Trichuris'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>      

            </tbody>

            <!-- Equine & Non Fluke -->
            <tbody v-if ="form.animaltype == 3 && form.test_type != 3">
              <tr>
                <td>Strongyle</td>
                <td> 
                  <input id = "Strongyle_input" type = "number" class="input" v-model="pestForm.Count_Strongyle" min="0" step="30" placeholder="-" >
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyle'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyle'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Strongyle' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Strongyle' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Strongyle'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Anoplocephala</td>
                <td> 
                  <input id = "Anoplocephala_input" type = "number" class="input" v-model="pestForm.Count_Anoplocephala" min="0" step="30" placeholder="-" >
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Anoplocephala'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Anoplocephala'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Anoplocephala' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Anoplocephala' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Anoplocephala'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr> 
                            <tr>
                <td>Parascaris</td>
                <td> 
                  <input id = "Parascaris_input" type = "number" class="input" v-model="pestForm.Count_Parascaris" min="0" step="30" placeholder="-" >
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Parascaris'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Parascaris'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Parascaris' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Parascaris' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Parascaris'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>   
              <tr>
                <td>Strongyloides</td>
                <td> 
                  <input id = "Strongyloides_input_equine" type = "number" class="input" v-model="pestForm.Count_Strongyloides" min="0" step="30" placeholder="-" >
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyloides'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyloides'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Strongyloides' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Strongyloides' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Strongyloides'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td colspan="1">
                  <label class="reviewer-flag-option">
                    <input type="checkbox" v-model="isChecked_inconclusive_strongyloides" @change="handleCheckboxinconclusive"/>
                    Invalid
                  </label>
                </td>
              </tr>                     
              <tr>
                <td>Coccidia</td>
                <td> 
                  <input id = "Coccidia_input" type = "number" class="input" v-model="pestForm.Count_Coccidia" :disabled="isChecked_present_uncounted" min="0" step="30" placeholder="-" >
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Coccidia'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Coccidia'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Coccidia' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Coccidia' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Coccidia'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td colspan="1">
                  <label class="reviewer-flag-option">
                    <input type="checkbox" v-model="isChecked_inconclusive" :disabled="isChecked_present_uncounted" @change="handleCheckboxinconclusive"/>
                    Invalid
                  </label>
                  <label class="reviewer-flag-option">
                    <input type="checkbox" v-model="isChecked_present_uncounted" :disabled="isChecked_inconclusive" @change="handleCheckboxPresentUncounted"/>
                    Present (uncounted)
                  </label>
                </td>
              </tr>
                    
            </tbody>

            <!-- Non Equine & Fluke -->
            <tbody v-if="form.test_type == 3 && form.animaltype != 3">
              <tr>
                <td>Liver Fluke</td>
                <td> 
                  <input id = "LiverFluke_input" type = "number" class="input" v-model="pestForm.Count_LiverFluke" min="0" step="3" placeholder="-" >
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Liver Fluke'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Liver Fluke'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Liver Fluke' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Liver Fluke' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Liver Fluke'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>


              </tr>

              <tr>
                <td>Rumen Fluke</td>
                <td> 
                  <input id = "RumenFluke_input" type = "number" class="input" v-model="pestForm.Count_RumenFluke" min="0" step="3" placeholder="-" >
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Rumen Fluke'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Rumen Fluke'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Rumen Fluke' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Rumen Fluke' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Rumen Fluke'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>

              </tr>
            </tbody>

            <!-- Equine & Fluke -->
            <tbody v-if="form.test_type == 3 && form.animaltype == 3">
              <tr>
                <td>Liver Fluke</td>
                <td> 
                  <input id = "LiverFluke_input" type = "number" class="input" v-model="pestForm.Count_LiverFluke" min="0" step="3" placeholder="-" >
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Liver Fluke'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Liver Fluke'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Liver Fluke' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Liver Fluke' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Liver Fluke'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>


              </tr>
            </tbody>

            <!-- Companion Animals -->
            <tbody v-if="form.test_type == 4">

              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'Roundworm' }"
              >
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Roundworm'" @mouseleave="handleMouseLeave">
                    Roundworm
                    <div class="egg-tooltip-content">
                      <img src="@/assets/parasites/Roundworm.png" class="egg-thumbnail" />
                    </div>
                  </div>
                </td>
                <td>
                  <div class="larvae-checkbox-container">
                    <input
                      type="checkbox"
                      class="larvae-checkbox"
                      v-model="petDetection['Roundworm']"
                      :disabled="petInvalid['Roundworm']"
                      @mouseover="activeTooltip = 'Roundworm'"
                      @mouseleave="handleMouseLeave"
                      @focus="activeTooltip = 'Roundworm'"
                      @blur="handleBlur"
                    />
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Roundworm'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Roundworm'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Roundworm' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Roundworm' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Roundworm'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>
                </td>
                <td colspan="1">
                  <label class="reviewer-flag-option">
                    <input type="checkbox" class="pet-invalid-checkbox" v-model="petInvalid['Roundworm']" />
                    Invalid
                  </label>
                </td>
              </tr>
              
              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'Whipworm' }"
              >
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Whipworm'" @mouseleave="handleMouseLeave">
                    Whipworm
                    <div class="egg-tooltip-content">
                      <img src="@/assets/parasites/Whipworm.png" class="egg-thumbnail" />
                    </div>
                  </div>
                </td>
                <td>
                  <div class="larvae-checkbox-container">
                    <input
                      type="checkbox"
                      class="larvae-checkbox"
                      v-model="petDetection['Whipworm']"
                      @mouseover="activeTooltip = 'Whipworm'"
                      @mouseleave="handleMouseLeave"
                      @focus="activeTooltip = 'Whipworm'"
                      @blur="handleBlur"
                    />
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Whipworm'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Whipworm'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Whipworm' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Whipworm' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Whipworm'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr> 

              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'Hookworm' }"
              >
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Hookworm'" @mouseleave="handleMouseLeave">
                    Hookworm
                    <div class="egg-tooltip-content">
                      <img src="@/assets/parasites/Hookworm.png" class="egg-thumbnail" />
                    </div>
                  </div>
                </td>
                <td>
                  <div class="larvae-checkbox-container">
                    <input
                      type="checkbox"
                      class="larvae-checkbox"
                      v-model="petDetection['Hookworm']"
                      @mouseover="activeTooltip = 'Hookworm'"
                      @mouseleave="handleMouseLeave"
                      @focus="activeTooltip = 'Hookworm'"
                      @blur="handleBlur"
                    />
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Hookworm'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Hookworm'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Hookworm' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Hookworm' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Hookworm'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>   

              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'Tapeworm' }"
              >
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Tapeworm'" @mouseleave="handleMouseLeave">
                    Tapeworm
                    <div class="egg-tooltip-content">
                      <img src="@/assets/parasites/Tapeworm.png" class="egg-thumbnail" />
                    </div>
                  </div>
                </td>
                <td>
                  <div class="larvae-checkbox-container">
                    <input
                      type="checkbox"
                      class="larvae-checkbox"
                      v-model="petDetection['Tapeworm']"
                      @mouseover="activeTooltip = 'Tapeworm'"
                      @mouseleave="handleMouseLeave"
                      @focus="activeTooltip = 'Tapeworm'"
                      @blur="handleBlur"
                    />
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Tapeworm'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Tapeworm'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Tapeworm' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Tapeworm' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Tapeworm'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>   

              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'Capillaria' }"
              >
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Capillaria'" @mouseleave="handleMouseLeave">
                    Capillaria
                    <div class="egg-tooltip-content">
                      <img src="@/assets/parasites/Capillaria.png" class="egg-thumbnail" />
                    </div>
                  </div>
                </td>
                <td>
                  <div class="larvae-checkbox-container">
                    <input
                      type="checkbox"
                      class="larvae-checkbox"
                      v-model="petDetection['Capillaria']"
                      @mouseover="activeTooltip = 'Capillaria'"
                      @mouseleave="handleMouseLeave"
                      @focus="activeTooltip = 'Capillaria'"
                      @blur="handleBlur"
                    />
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Capillaria'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Capillaria'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Capillaria' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Capillaria' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Capillaria'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>   

              <tr>
                <td>Coccidia</td>
                <td>
                  <div class="larvae-checkbox-container">
                    <input type="checkbox" class="larvae-checkbox" v-model="petDetection['Coccidia']" :disabled="petInvalid['Coccidia']" />
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Coccidia'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Coccidia'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template>
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Coccidia' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Coccidia' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>
                    </template>
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Coccidia'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>
                </td>
                <td colspan="1">
                  <label class="reviewer-flag-option">
                    <input type="checkbox" class="pet-invalid-checkbox" v-model="petInvalid['Coccidia']" />
                    Invalid
                  </label>
                </td>
              </tr>



            </tbody>

            <!-- Poultry & WORM FEC -->
            <tbody v-if="form.animaltype == 7 && form.test_type == 1">
              <tr>
                <td>Coccidia</td>
                <td> 
                  <input id = "Coccidia_input" type = "number" class="input" v-model="pestForm.Count_Coccidia" :disabled="isChecked_present_uncounted" min="0" step="30" placeholder="-" >
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Coccidia'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Coccidia'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Coccidia' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Coccidia' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Coccidia'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td colspan="1">
                  <label class="reviewer-flag-option">
                    <input type="checkbox" v-model="isChecked_inconclusive" :disabled="isChecked_present_uncounted" @change="handleCheckboxinconclusive"/>
                    Invalid
                  </label>
                  <label class="reviewer-flag-option">
                    <input type="checkbox" v-model="isChecked_present_uncounted" :disabled="isChecked_inconclusive" @change="handleCheckboxPresentUncounted"/>
                    Present (uncounted)
                  </label>
                </td>
              </tr>
              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'Ascaridia' }"
              >
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Ascaridia'" @mouseleave="handleMouseLeave">
                    Ascaridia
                    <div class="egg-tooltip-content egg-tooltip-dual">
                      <div class="egg-tooltip-dual-item">
                        <img src="@/assets/parasites/HeterakisGallinarum.png" class="egg-thumbnail" />
                        <span class="egg-tooltip-label">H. gallinarum</span>
                      </div>
                      <div class="egg-tooltip-dual-item">
                        <img src="@/assets/parasites/AscaridiaGalli.png" class="egg-thumbnail" />
                        <span class="egg-tooltip-label">A. galli</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <input
                    id="Ascaridia_input"
                    type="number"
                    class="input"
                    v-model="pestForm.Count_Ascaridia"
                    min="0"
                    step="30"
                    placeholder="-"
                    @focus="activeTooltip = 'Ascaridia'"
                    @blur="handleBlur"
                  />
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Ascaridia'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Ascaridia'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Ascaridia' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Ascaridia' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Ascaridia'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>
              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'Capillaria' }"
              >
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Capillaria'" @mouseleave="handleMouseLeave">
                    Capillaria
                    <div class="egg-tooltip-content">
                      <img src="@/assets/parasites/Capillaria.png" class="egg-thumbnail" />
                    </div>
                  </div>
                </td>
                <td>
                  <input
                    id="Capillaria_input"
                    type="number"
                    class="input"
                    v-model="pestForm.Count_Capillaria"
                    min="0"
                    step="30"
                    placeholder="-"
                    @focus="activeTooltip = 'Capillaria'"
                    @blur="handleBlur"
                  />
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Capillaria'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Capillaria'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Capillaria' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Capillaria' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Capillaria'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>
              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'Syngamus' }"
              >
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Syngamus'" @mouseleave="handleMouseLeave">
                    Syngamus
                    <div class="egg-tooltip-content">
                      <img src="@/assets/parasites/Syngamus.png" class="egg-thumbnail" />
                    </div>
                  </div>
                </td>
                <td>
                  <input
                    id="Syngamus_input"
                    type="number"
                    class="input"
                    v-model="pestForm.Count_Syngamus"
                    min="0"
                    step="30"
                    placeholder="-"
                    @focus="activeTooltip = 'Syngamus'"
                    @blur="handleBlur"
                  />
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Syngamus'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Syngamus'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Syngamus' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Syngamus' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Syngamus'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>
              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'Tapeworm' }"
              >
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Tapeworm'" @mouseleave="handleMouseLeave">
                    Tapeworm
                    <div class="egg-tooltip-content">
                      <img src="@/assets/parasites/Tapeworm.png" class="egg-thumbnail" />
                    </div>
                  </div>
                </td>
                <td>
                  <input
                    id="Tapeworm_input"
                    type="number"
                    class="input"
                    v-model="pestForm.Count_Tapeworm"
                    min="0"
                    step="30"
                    placeholder="-"
                    @focus="activeTooltip = 'Tapeworm'"
                    @blur="handleBlur"
                  />
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Tapeworm'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Tapeworm'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Tapeworm' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Tapeworm' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Tapeworm'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Strongyle</td>
                <td> 
                  <input id = "Strongyle_input" type = "number" class="input" v-model="pestForm.Count_Strongyle" min="0" step="30" placeholder="-" >
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyle'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyle'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Strongyle' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Strongyle' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Strongyle'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>

              </tr>
  
            </tbody>

            <!-- Alpaca & Llama & WORM FEC -->
            <tbody v-if="(form.animaltype == 8 || form.animaltype == 9) && form.test_type != 3">
              <tr>
                <td 
                  id = "pestForm.Type">
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Coccidia'" @mouseleave="handleMouseLeave">
                    Coccidia
                  </div>
                </td>
                <td> 
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Coccidia'" @mouseleave="handleMouseLeave">
                    <input
                      id = "Coccidia_input"
                      type = "number"
                      class="input"
                      v-model="pestForm.Count_Coccidia"
                      :disabled="isChecked_present_uncounted"
                      min="0"
                      step="30"
                      placeholder="-"
                      @focus="activeTooltip = 'Coccidia'"
                      @blur="handleBlur">
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Coccidia'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Coccidia'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Coccidia' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Coccidia' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Coccidia'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td colspan="1">
                  <label class="reviewer-flag-option">
                    <input type="checkbox" v-model="isChecked_inconclusive" :disabled="isChecked_present_uncounted" @change="handleCheckboxinconclusive"/>
                    Invalid
                  </label>
                  <label class="reviewer-flag-option">
                    <input type="checkbox" v-model="isChecked_present_uncounted" :disabled="isChecked_inconclusive" @change="handleCheckboxPresentUncounted"/>
                    Present (uncounted)
                  </label>
                </td>

              </tr>
              <tr>
                <td id = "pestForm.Type">
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'EimeriaMacusaniensis'" @mouseleave="handleMouseLeave">
                    E. Macusaniensis
                  </div>
                </td>
                <td> 
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'EimeriaMacusaniensis'" @mouseleave="handleMouseLeave">
                    <input 
                      id = "Eimeria_Macusaniensis_input" 
                      type = "number" 
                      class="input" 
                      v-model="pestForm.Count_Eimeria_Macusaniensis" 
                      min="0" 
                      step="30" 
                      placeholder="-" 
                      @focus="activeTooltip = 'EimeriaMacusaniensis'"
                      @blur="handleBlur"
                    >
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'E. Macusaniensis'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'E. Macusaniensis'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'E. Macusaniensis' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'E. Macusaniensis' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'E. Macusaniensis'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
               
              </tr>
              <tr>
                <td id = "pestForm.Type">
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'EimeriaIvitaensis'" @mouseleave="handleMouseLeave">
                    E. Ivitaensis
                  </div>
                </td>
                <td> 
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'EimeriaIvitaensis'" @mouseleave="handleMouseLeave">
                    <input 
                      id = "Eimeria_Ivitaensis_input" 
                      type = "number" 
                      class="input" 
                      v-model="pestForm.Count_Eimeria_Ivitaensis" 
                      min="0" 
                      step="30" 
                      placeholder="-" 
                      @focus="activeTooltip = 'EimeriaIvitaensis'"
                      @blur="handleBlur"
                    >
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'E. Ivitaensis'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'E. Ivitaensis'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'E. Ivitaensis' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'E. Ivitaensis' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'E. Ivitaensis'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
               
              </tr>
              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'Capillaria' }"
              >
                <td id = "pestForm.Type">
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Capillaria'" @mouseleave="handleMouseLeave">
                    Capillaria
                    <div class="egg-tooltip-content">
                      <img src="@/assets/parasites/Capillaria.png" class="egg-thumbnail" />
                    </div>
                  </div>
                </td>
                <td> 
                  <input
                    id="Capillaria_input"
                    type="number"
                    class="input"
                    v-model="pestForm.Count_Capillaria"
                    min="0"
                    step="30"
                    placeholder="-"
                    @focus="activeTooltip = 'Capillaria'"
                    @blur="handleBlur"
                  />
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Capillaria'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Capillaria'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Capillaria' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Capillaria' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Capillaria'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
               
              </tr>
              <tr>
                <td id = "pestForm.Type">
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Trichuris'" @mouseleave="handleMouseLeave">
                    Trichuris
                  </div>
                </td>
                <td> 
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Trichuris'" @mouseleave="handleMouseLeave">
                    <input 
                      id = "Trichuris_input" 
                      type = "number" 
                      class="input" 
                      v-model="pestForm.Count_Trichuris" 
                      min="0" 
                      step="30" 
                      placeholder="-" 
                      @focus="activeTooltip = 'Trichuris'"
                      @blur="handleBlur"
                    >
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Trichuris'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Trichuris'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Trichuris' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Trichuris' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Trichuris'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>      
              <tr>
                <td id = "pestForm.Type">
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Marshalaga'" @mouseleave="handleMouseLeave">
                    Marshalaga
                  </div>
                </td>
                <td> 
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Marshalaga'" @mouseleave="handleMouseLeave">
                    <input 
                      id = "Marshalaga_input" 
                      type = "number" 
                      class="input" 
                      v-model="pestForm.Count_Marshalaga" 
                      min="0" 
                      step="30" 
                      placeholder="-" 
                      @focus="activeTooltip = 'Marshalaga'"
                      @blur="handleBlur"
                    >
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Marshalaga'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Marshalaga'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Marshalaga' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Marshalaga' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Marshalaga'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>

              </tr> 

              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'NemaBattus' }"                
              >
                <td>                  
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'NemaBattus'" @mouseleave="handleMouseLeave">
                    Nematodirus battus
                    <div class="egg-tooltip-content">
                      <img src="@/assets/parasites/NemaBattus.png" class="egg-thumbnail" />
                    </div>
                  </div>
                </td>
                <td>
                  <input
                    id="Nematodirus_battus_input"
                    type="number"
                    class="input"
                    v-model="pestForm.Count_Nematodirus_Battus"
                    min="0"
                    step="30"
                    placeholder="-"
                    @focus="activeTooltip = 'NemaBattus'"                    
                    @blur="handleBlur"
                  />
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Nematodirus battus'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Nematodirus battus'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Nematodirus battus' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Nematodirus battus' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Nematodirus battus'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>           

              <tr
                class="egg-tooltip-row"
                :class="{ 'tooltip-visible': activeTooltip === 'NemaSpp' }"                
              >
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'NemaSpp'" @mouseleave="handleMouseLeave">
                    Nematodirus spp
                    <div class="egg-tooltip-content">
                      <img src="@/assets/parasites/NemaSpp.png" class="egg-thumbnail" />
                    </div>
                  </div>
                </td>
                <td>
                  <input
                    id="Nematodirus_spp_input"
                    type="number"
                    class="input"
                    v-model="pestForm.Count_Nematodirus_Spp"
                    min="0"
                    step="30"
                    placeholder="-"
                    @focus="activeTooltip = 'NemaSpp'"
                    @blur="handleBlur"
                  />
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Nematodirus'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Nematodirus'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Nematodirus' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Nematodirus' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Nematodirus'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
              </tr>        

              <tr>
                <td id = "pestForm.Type">
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Strongyle'" @mouseleave="handleMouseLeave">
                    Strongyle
                  </div>
                </td>
                <td> 
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Strongyle'" @mouseleave="handleMouseLeave">
                    <input 
                      id = "Strongyle_input" 
                      type = "number" 
                      class="input" 
                      v-model="pestForm.Count_Strongyle" 
                      min="0" 
                      step="30" 
                      placeholder="-" 
                      @focus="activeTooltip = 'Strongyle'"
                      @blur="handleBlur"
                    >
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyle'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyle'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Strongyle' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Strongyle' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Strongyle'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>
               
              </tr>

              <tr>
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Strongyloides'" @mouseleave="handleMouseLeave">
                    Strongyloides
                  </div>
                </td>
                <td>
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Strongyloides'" @mouseleave="handleMouseLeave">
                    <input 
                      id = "Strongyloides_input" 
                      type = "number" 
                      class="input" 
                      v-model="pestForm.Count_Strongyloides" 
                      min="0" 
                      step="30" 
                      placeholder="-" 
                      @focus="activeTooltip = 'Strongyloides'"
                      @blur="handleBlur"
                    >
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyloides'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Strongyloides'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Strongyloides' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Strongyloides' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Strongyloides'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td colspan="1">
                  <label class="reviewer-flag-option">
                    <input type="checkbox" v-model="isChecked_inconclusive_strongyloides" @change="handleCheckboxinconclusive"/>
                    Invalid
                  </label>
                </td>

              </tr>                                                 
              <tr>
                <td 
                  id = "pestForm.Type">
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Moniezia'" @mouseleave="handleMouseLeave">
                    Moniezia
                  </div>                  
                </td>
                <td> 
                  <div class="egg-tooltip-container" @mouseover="activeTooltip = 'Moniezia'" @mouseleave="handleMouseLeave">
                    <input 
                      id = "Moniezia_input" 
                      type = "number" 
                      class="input" 
                      v-model="pestForm.Count_Moniezia" 
                      min="0" 
                      step="30" 
                      placeholder="-" 
                      @focus="activeTooltip = 'Moniezia'"
                      @blur="handleBlur"
                    >
                  </div>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Moniezia'">
                    {{ countOutput(pest.pest_count, pest.count_qualifier) }}
                    </template>
                  </template> 
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Moniezia'">
                    {{ countOutput(pest.original_count) }}
                    </template>
                  </template> 
                </td>
                <td>
                      <template v-for="pest in pests" :key="pest.id">
                        <template v-if="pest.pest === 'Moniezia' && pest.status == 'negative'">
                          <span class="icon icon-heart" style="color: #04a394"></span>
                        </template>
                        <template v-if="pest.pest === 'Moniezia' && pest.status == 'positive'">
                          <span class="icon icon-heart" style="color: #d50014"></span>
                        </template>                      
                    </template> 
                </td>
                <td>
                    <template v-for="pest in pests" :key="pest.id">
                      <template v-if="pest.pest === 'Moniezia'">
                                {{ TimeParse(pest.created_at) }}
                      </template>
                    </template>  
                </td>
                <td></td>

              </tr> 
            </tbody>

            <!-- Larvae: show if business requires it OR if this test already has larvae data saved (non-Fluke only) -->
            <tbody v-if="form.test_type != 3 && form.test_type != 4 && (form.larvae_required === true || hasLarvaeData)">
              <tr class="larvae-required-row">
                <td id="pestForm.Type">Larvae</td>
                <td>
                  <div class="larvae-checkbox-container">
                    <input 
                      type="checkbox" 
                      id="larvae-positive-checkbox"
                      class="larvae-checkbox"
                      v-model="larvaeForm.is_positive" 
                    />                    
                  </div>
                </td>
                <td>-</td>
                <td>-</td>
                <td>
                  <template v-if="!hasLarvaeData && hasAnyPestData">
                    <span class="larvae-not-analysed">Not analysed</span>
                  </template>
                  <template v-else-if="larvaeForm.is_positive === false && hasLarvaeData">
                    <span class="icon icon-heart" style="color: #04a394"></span>
                  </template>
                  <template v-else-if="larvaeForm.is_positive === true && hasLarvaeData">
                    <span class="icon icon-heart" style="color: #d50014"></span>
                  </template>
                </td>
                <td>
                  <template v-for="pest in pests" :key="pest.id">
                    <template v-if="pest.pest === 'Larvae'">
                      {{ TimeParse(pest.created_at) }}
                    </template>
                  </template>
                </td>
                <td></td>
              </tr>
            </tbody>

            
           
          </table>
          </div>
          <br />
          
          <!-- Quality banner. Absent when nothing is known about a test a
               reviewer has already saved: raising a question that is closed
               reads as an alarm. -->
          <div
            v-if="qualityBanner"
            class="flag-indicator"
            :class="'flag-indicator--' + qualityBanner.variant"
            role="alert"
            aria-live="polite"
          >
            <div class="flag-indicator__icon">
              <img
                v-if="qualityBanner.variant === 'reject'"
                src="@/assets/video_icon.png"
                alt=""
              />
              <span v-else>{{ qualityBanner.icon }}</span>
            </div>
            <div class="flag-indicator__content">
              <h4 class="flag-indicator__title">{{ qualityBanner.title }}</h4>
              <p
                v-if="qualityBanner.message"
                class="flag-indicator__message"
              >{{ qualityBanner.message }}</p>
            </div>
            <!-- Outside __content on purpose: as a direct child it spans both
                 grid columns and starts level with the icon. -->
            <ul v-if="qualityBanner.findings" class="flag-indicator__findings">
              <li
                v-for="finding in qualityBanner.findings"
                :key="finding.label"
                class="flag-indicator__finding"
              >
                <span class="flag-indicator__finding-stage">{{ finding.category }}</span>
                <span class="flag-indicator__finding-name">{{ finding.label }}</span>
                <span class="flag-indicator__finding-statement">{{ finding.statement }}</span>
              </li>
            </ul>
            <p
              v-if="qualityBanner.couldNotRun"
              class="flag-indicator__unrun"
            >{{ qualityBanner.couldNotRun }}</p>
          </div>
          </div>
          <!-- /table-flag-group -->

            <!-- Copy ML Checkbox - conditional rendering -->
            <div v-if="shouldShowCopyMLCheckbox && form.test_type != 4" class="copy-ml-section">
              <label>
                <input 
                  type="checkbox" 
                  v-model="isChecked"
                  @change="handleCheckboxChange"
                />
                Copy results from ML?
              </label>
            </div>
          </FormSection>
            
            <!-- <button v-on:click="AddResult_full" class="btn btn-green">Save Results<i class="icon icon-pen"></i>
                  </button> -->
          <FormSection title="Review information">
            <label id = "Reviewed_by" for="form.reviewed_by">Reviewed By : </label>
            <img
              v-if="form.auto_saved && form.status === 'red'"
              src="@/assets/ml-redheart-filled.png"
              class="reviewed-by-ml"
              alt="Released automatically"
              title="Released automatically. The video reported no problems and the counts met the rule for releasing a positive result, so this test was saved without a reviewer."
            />
            <img
              v-else-if="form.auto_saved"
              src="@/assets/ml-heart-filled.png"
              class="reviewed-by-ml"
              alt="Released automatically"
              title="Released automatically. The analysis found nothing and reported no problems with the video, so this test was saved without a reviewer."
            />
            <input type="text" v-model="form.reviewed_by" class="input" readonly/> 
        
          <br/>
           <br/>

            <label for="form.reviewer_obs">Reviewer Observations: (Select multiple using 'CTRL +')</label>
            <br/>
            <div v-if="form.reviewer_obs && form.reviewer_obs.length > 0" class="reviewer-obs-clear-container">
              <button 
                type="button" 
                @click="clearReviewerObs" 
                class="btn-link-clear"
                title="Clear all selected observations"
              >
                <span style="margin-right: 4px;">✕</span> Clear All
              </button>
            </div>
            
            <!-- Flex container for select and display -->
            <div class="reviewer-obs-layout">
              <select 
                name="form.reviewer_obs" 
                id="form.reviewer_obs" 
                class="input reviewer-obs-select" 
                v-model="form.reviewer_obs" 
                size="8" 
                multiple
              >                                       
                <option value="Poor focus">Poor focus</option>      
                <option value="Dirt on lens">Dirty Lens/ Slide</option>                                          
                <option value="Incorrect Alignment">Incorrect Alignment</option>        
                <option value="Dark/ Yellow">Dark/ Yellow</option>
                <option value="High Bubble Load">High Bubble Load</option>
                <option value="High Debri Load">High Debri Load</option>              
                <option value="Full Volume not Scanned">Full Volume not Scanned</option>                                                                                                        
                <option value="Motor Issue">Motor Issue</option>              
                <option value="Flickering Light">Flickering Light</option>              
                <option value="Camera Moving">Camera Moving</option>
                <option value="Old slide">Old slide</option>                                  
                <option value="Dead Eggs Present">Dead Eggs Present</option>                                                               
              </select>

              <!-- Display current selection with badges -->
              <div class="reviewer-obs-display-wrapper">
                <div 
                  v-if="form.reviewer_obs && form.reviewer_obs.length > 0" 
                  class="reviewer-obs-display"
                >
                  <strong style="display: block; margin-bottom: 8px; color: #374151;">Selected Observations:</strong>
                  <div class="obs-badges-container">
                    <span 
                      v-for="obs in form.reviewer_obs" 
                      :key="obs"
                      :class="['obs-badge', { 'obs-badge-legacy': isLegacyValue(obs) }]"
                      :title="isLegacyValue(obs) ? 'Legacy value - no longer in current options. Click to remove.' : 'Click to remove'"
                      @click="removeReviewerObs(obs)"
                    >
                      {{ obs }}                      
                      <span class="badge-remove-icon">✕</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

                   
          </FormSection>

          <FormSection title="Actions">
            <form class="form" v-on:submit.prevent>
            <label>{{ this.TimeToResults() }}</label>
            </form>
            <br />

            <button v-on:click="AddResult_full()" class="btn btn-green">
              Save Results<i class="icon icon-pen"></i>
            </button>
            <br/>
            <br/>
              <!-- <button
                class="btn btn-green"
                style="margin-right: 10px"
                v-on:click="OpenSaveChanges"
              >
                Push Results
              </button> -->


            <button
              v-if="
                pests.length > 0 &&
                this.form.status !== 'failed' &&
                this.form.status !== 'process'
              "
              class="btn btn-green"
              style="margin-right: 10px"
              v-on:click="this.downloadFEC()"
            >
              Download FEC Report
            </button>
          </FormSection>
        </div>
      </div>
    </div>
    <div id="savechanges-modal" class="modal">
      <div class="modal-content">
        <div class="row">
          <span class="close">&times;</span>
        </div>
        <div class="row">
          <div class="col-12" v-if="this.form.status!=='process' ">
            <div class="error" v-for="error in errMsg" :key="error">
              {{ error }}
            </div>
            <div class="success" v-for="message in msg" :key="message">
              {{ message }}
            </div>
            <p>Are you sure you want to update this test?</p>
            <br />
            <br />
            <input type="checkbox" id="notify" v-model="this.notify" />
            <label class="label" for="notify"
              >Send push notification to the user</label
            >
            <br />
            <br />
            <br />
            <button class="btn btn-green" v-on:click="UpdateTest" :disabled="modalLoading">
              Save Changes
            </button>
          </div>

          <div class="col-12" v-if="this.form.status =='process' ">

            <p>Please Input and Save the Test Results before pushing !</p>
            <br />

          </div>

        </div>
      </div>
    </div>

    <!-- Conflict Warning Modal -->
    <div
      id="conflict-warning-modal"
      class="modal"
      v-if="showConflictModal"
      style="display: block;"
      role="dialog"
      aria-modal="true"
      @click.self="cancelConflictOverride"
    >
      <div class="modal-content conflict-modal">
        <span class="close" @click="cancelConflictOverride" aria-label="Close">&times;</span>
        <div class="conflict-warning-header">          
          <h3>{{ conflictDetails && conflictDetails.lastUpdatedBy !== 'Unknown' ? 'Results Already Saved' : 'Incomplete Save Detected' }}</h3>
        </div>
        
        <div class="conflict-message">
          <!-- Message when reviewer is known (complete save) -->
          <p class="conflict-lead" v-if="conflictDetails && conflictDetails.lastUpdatedBy !== 'Unknown'">
            <strong>Warning:</strong> These test results have already been reviewed and saved.
          </p>
          
          <!-- Message when reviewer is unknown (incomplete/in-progress) -->
          <p class="conflict-lead" v-if="!conflictDetails || conflictDetails.lastUpdatedBy === 'Unknown'">
            <strong>Caution:</strong> A save attempt was detected, but the reviewer information is missing.
          </p>
          
          <div class="conflict-detail" v-if="conflictDetails">
            <div class="conflict-info-row" v-if="conflictDetails.lastUpdatedBy !== 'Unknown'">
              <span class="conflict-label">Reviewed By:</span>
              <span class="conflict-value">{{ conflictDetails.lastUpdatedBy }}</span>
            </div>
            <div class="conflict-info-row" v-else>
              <span class="conflict-label">Status:</span>
              <span class="conflict-value">Incomplete or Corrupted</span>
            </div>
            <div class="conflict-info-row">
              <span class="conflict-label">{{ conflictDetails.lastUpdatedBy !== 'Unknown' ? 'Last Saved At' : 'Save Attempted At' }}:</span>
              <span class="conflict-value">{{ formatConflictTime(conflictDetails.lastUpdatedAt) }}</span>
            </div>
          </div>
          
          <!-- Warning box for known reviewer -->
          <div class="conflict-warning-box" v-if="conflictDetails && conflictDetails.lastUpdatedBy !== 'Unknown'">            
            <p>Your changes will <strong>override</strong> the previously saved results.</p>
          </div>
          
          <!-- Warning box for unknown reviewer -->
          <div class="conflict-warning-box conflict-warning-box-unknown" v-if="!conflictDetails || conflictDetails.lastUpdatedBy === 'Unknown'">            
            <p><strong>Possible scenarios:</strong></p>
            <p>• The save process was interrupted or corrupted</p>
            <p>• Another user is currently working on this test</p>
            <p><strong>Recommendation:</strong> If you are not fixing an incomplete save, verify that no one else is working on this test before proceeding.</p>
          </div>
                    
        </div>
        
        <div class="conflict-actions">
          <button type="button" class="btn btn-danger" @click="confirmConflictOverride">
            Override Previous Results
          </button>
          <button type="button" class="btn btn-green" @click="cancelConflictOverride">
            Cancel & Review
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import Navigation from "@/components/Navigation";
import Admin_Tests_Header from "@/components/Admin.Tests.Header";
import Admin_Tests_VideoViewer from "@/components/Admin.Tests.VideoViewer";
import Admin_Tests_WhiteBalance from "@/components/Admin.Tests.WhiteBalance";
import Admin_Tests_DoubleCheckBadge from "@/components/Admin.Tests.DoubleCheckBadge";
import FormSection from "@/components/FormSection.vue";
import axios from "axios";
import { saveAs } from "file-saver";
import html2pdf from "html2pdf.js";
import scrollToTop from "@/mixins/scrollToTop";
import {
  resolveBanner,
  shouldOfferMlCopy,
} from "@/utils/mlReliabilityBanner";


export default {
  name: "Admin_Tests_Modify",
  mixins: [scrollToTop],
  setup() {
    const store = useStore();

    return { store };
  },
  components: {
    Navigation,
    Admin_Tests_Header,
    Admin_Tests_VideoViewer,
    Admin_Tests_WhiteBalance,
    Admin_Tests_DoubleCheckBadge,
    FormSection,
  },
  computed: {
    hasLarvaeData() {
      return Array.isArray(this.pests) && this.pests.some(
        (p) => (p.pest || "").toLowerCase() === "larvae"
      );
    },
    hasAnyPestData() {
      return Array.isArray(this.pests) && this.pests.length > 0;
    },
        FullName() {
      return this.store.state["User"].info.name;
    },
    countOutput() {
      return (value, qualifier) => {
        // Pet tests are detection-only: pest_count is a nominal value, render a label.
        if (this.form.test_type == 4) {
          if (value === 1) return "Detected";
          if (value === 0) return "Not Detected";
          if (value === -1) return "Invalid";
          return "—"; // -2 / empty = pending
        }
        // Coccidia detected-but-not-countable is stored as Count -1 but carries a
        // qualifier, so show "Detected" rather than the legacy "Invalid" label.
        if (qualifier === "PRESENT_UNCOUNTED") {
          return "Detected";
        }
        if (value === -1) {
          return "Invalid";
        }
        else if (value === -2){
          return "Counting in-progress";
        }
        else {
          return value;
        }
      };
    },
    shouldShowCopyMLCheckbox() {
      // Only on a clean verdict. One finding is enough to withhold the ML
      // counts, and so is a test nothing was able to check.
      return shouldOfferMlCopy(this.mlReliability);
    },

    qualityBanner() {
      // Every branch lives in the resolver so the five cases can be read
      // together rather than inferred from conditions spread across a
      // component. Null means show nothing at all.
      return resolveBanner({
        assessment: this.mlReliability,
        // Absent rather than false when an older API is answering, and a
        // missing field must not read as "no analysis was ever asked for".
        mlDispatched: this.form.ml_dispatched !== false,
        reviewedAt: this.form.reviewed_at,
        // Counts on a test nobody has saved can only have come from the
        // pipeline, which is what separates an analysis that finished without
        // an assessment from one that has not finished.
        hasCounts: this.hasAnyPestData,
      });
    }
  },
  data() {
    
    return {
      loading: false,
      modalLoading: false,     
      activeTooltip: null, 

      failreasons: [
        "A large air bubble is present in the slide.\n",
        "Too many small air bubbles.\n",
        "Water on the slide.\n",
        "The full slide was not captured.\n",
        "The full Fluke slide was not captured.\n",
        "No image was detected.\n",
        "Incorrect phone alignment.\n",
        "The sample is too dark for accurate processing affecting egg visibility.\n",
        "Poor focus affecting visibility.\n",
        "Technical issue.\n"
      ],

      pestTypes_bovine: [
        "Coccidia",
        "Strongyle",
        "Nematodirus battus",
        "Nematodirus spp",
        "Trichuris",
        "Strongyloides",
        "Moniezia",
      ],
      pestTypes_ovine: [
        "Coccidia",
        "Strongyle",
        "Nematodirus battus",
        "Nematodirus spp",
        "Trichuris",
        "Strongyloides",
        "Moniezia",
      ],
      pestTypes_caprine: [
        "Coccidia",
        "Strongyle",
        "Nematodirus battus",
        "Nematodirus spp",
        "Trichuris",
        "Strongyloides",
        "Moniezia",
      ],
      pestTypes_equine: [
        "Coccidia",
        "Strongyle",
        "Parascaris",
        "Strongyloides",
        "Anoplocephala",
      ],
      pestTypes_alpaca: [
        "Coccidia",
        "E. Macusaniensis",
        "E. Ivitaensis",
        "Capillaria",
        "Trichuris",
        "Marshalaga",
        "Nematodirus battus",
        "Nematodirus spp",
        "Strongyle",
        "Strongyloides",
        "Moniezia",
      ],
      pestTypes_llama: [
        "Coccidia",
        "E. Macusaniensis",
        "E. Ivitaensis",
        "Capillaria",
        "Trichuris",
        "Marshalaga",
        "Nematodirus battus",
        "Nematodirus spp",
        "Strongyle",
        "Strongyloides",
        "Moniezia",
      ],
      errMsg: "",
      msg: "",
      // Conflict detection for concurrent edits
      showConflictModal: false,
      conflictDetails: null,
      form: {
        cow_id: "",
        status: "",
        created_at: "",
        bucket_file: null,
        tester_name: null,
        original_file: "1111",
        request_id: "",
        pdf: "",
        farmer_name: "",
        vet_practice_name: "",
        sampletype: 1,
        animaltype: 1,
        test_type:1,
        detected_bucket_file: null,
        notes: "",
        failreason: "",
        failreasons_drop: "",
        fail_comments:"",
        reviewed_by: this.store.state["User"].info.name,
        reviewer_obs: [],
        reviewed_at: "",
        larvae_required: false
      },
      pestForm: {
        Type: "",
        Count_Coccidia: "",
        Count_Strongyle: "",
        Count_Nematodirus_Battus: "",
        Count_Nematodirus_Spp: "",
        Count_Strongyloides: "",
        Count_Moniezia: "",
        Count_Anoplocephala: "",
        Count_Parascaris: "",
        Count_Trichuris: "",
        Count_LiverFluke: "",
        Count_RumenFluke: "",
        Count_Roundworm: "",
        Count_Whipworm: "",
        Count_Hookworm: "",
        Count_Tracheal_Worm: "",
        Count_Ascaridia: "",
        Count_Capillaria: "",
        Count_Syngamus: "",
        Count_Tapeworm: "",
        Count_Eimeria_Macusaniensis: "",
        Count_Eimeria_Ivitaensis: "",
        Count_Marshalaga: "",
        Status: "",
        Count:0,
        Inconclusive: false,
      },
      larvaeForm: {
        is_positive: false
      },
      // Pet tests (test_type 4) are detection-only: one boolean per parasite.
      petDetection: {
        Roundworm: false,
        Whipworm: false,
        Hookworm: false,
        Tapeworm: false,
        Capillaria: false,
        Coccidia: false,
      },
      // "Invalid / could not assess" toggle — only Coccidia and Roundworm (per PO).
      petInvalid: {
        Roundworm: false,
        Coccidia: false,
      },
      pests: "",
      playerOptions: {
        height: "280",
        autoplay: false,
        muted: true,
        controls: true,
        language: "en",
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        sources: [],
      },
      playerOptions_dect: {
        height: "280",
        autoplay: false,
        muted: true,
        controls: true,
        language: "en",
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        sources: [],
      },

      // Valid reviewer observation options (for validation and legacy detection)
      validObsOptions: [
        "Poor focus",
        "Dirt on lens",
        "Incorrect Alignment",
        "Dark/ Yellow",
        "High Bubble Load",
        "High Debri Load",
        "Full Volume not Scanned",
        "Motor Issue",
        "Flickering Light",
        "Camera Moving",
        "Old slide",
        "Dead Eggs Present"
      ],
      
      notify: true,
      isChecked: false,
      isChecked_inconclusive :false,
      isChecked_inconclusive_strongyloides : false,
      // Coccidia-only, non-pet: "detected but not countable". Mutually exclusive
      // with the count input and the Invalid checkbox. Sends CountQualifier:
      // "PRESENT_UNCOUNTED" on save. Shared across the non-pet tbody blocks since
      // only one renders at a time (same pattern as isChecked_inconclusive).
      isChecked_present_uncounted: false,

      // What the ML pipeline said about the reliability of its own results.
      // Null means no assessment exists, which is not the same as a clean one.
      mlReliability: null
    };
  },
  methods: {
    /**
     * Parse reviewer_obs from various formats to standardised array
     * Handles: PostgreSQL array format, legacy strings, arrays
     * @param {*} value - The raw reviewer_obs value from API
     * @returns {Array} - Normalised array of observation strings
     */
    parseReviewerObs(value) {
      console.log('[reviewer_obs] Raw value from API:', value, 'Type:', typeof value);
      
      // Handle null/undefined/empty
      if (!value) {
        console.log('[reviewer_obs] Parsed to empty array (null/undefined)');
        return [];
      }
      
      // Already an array - return copy
      if (Array.isArray(value)) {
        console.log('[reviewer_obs] Already array:', value);
        return [...value];
      }
      
      // String processing
      if (typeof value === 'string') {
        // PostgreSQL array format: "{\"Flickering Light\",\"Camera Moving\"}"
        if (value.startsWith('{') && value.endsWith('}')) {
          const parsed = value
            .slice(1, -1)
            .split(',')
            .map(item => item.replace(/^"|"$/g, '').trim())  // Remove quotes
            .filter(item => item.length > 0);
          console.log('[reviewer_obs] Parsed PostgreSQL format to:', parsed);
          return parsed;
        }
        
        // Legacy single string values (including "All good!")
        const trimmed = value.trim();
        if (trimmed !== '' && trimmed !== 'All good!') {
          console.log('[reviewer_obs] Parsed legacy string to array:', [trimmed]);
          return [trimmed];
        }
        
        // Empty string or "All good!" → empty array
        console.log('[reviewer_obs] Parsed to empty array (empty/All good)');
        return [];
      }
      
      // Unexpected type
      console.warn('[reviewer_obs] Unexpected type, defaulting to empty array:', typeof value);
      return [];
    },

    /**
     * Check if an observation value is a legacy value (not in current options)
     * @param {string} value - The observation value to check
     * @returns {boolean} - True if legacy value
     */
    isLegacyValue(value) {
      return !this.validObsOptions.includes(value);
    },

    /**
     * Clear all selected reviewer observations
     */
    clearReviewerObs() {
      console.log('[clearReviewerObs] Clearing all observations');
      this.form.reviewer_obs = [];
    },

    removeReviewerObs(obsToRemove) {
      console.log('[removeReviewerObs] Removing observation:', obsToRemove);
      this.form.reviewer_obs = this.form.reviewer_obs.filter(obs => obs !== obsToRemove);
    },

    handleMouseLeave() {
      // Only clear if it was hover, not while input still focused
      if (document.activeElement.tagName !== 'INPUT') {
        this.activeTooltip = null;
      }
    },
    handleBlur() {
      // Only hide if mouse isn't still hovering
      const hovered = document.querySelector(':hover');
      if (!hovered || !hovered.closest('.egg-tooltip-row')) {
        this.activeTooltip = null;
      }
    },

    handleBeforeUnload(event) {

      if((this.form.status =='process') || (this.form.reviewed_by =='') ){
      // Customize the confirmation message
      const confirmationMessage = "Are you sure you want to leave this page?";
      // Set the confirmation message
      event.returnValue = confirmationMessage;
      return confirmationMessage;
      }
    },

    GetData() {
      return this.store
        .dispatch("Admin/GetTestInfo", this.$route.params.id)
        .then((result) => {
          this.form = result.data;
          // Default to false unless backend sends a strict boolean true
          this.form.larvae_required = result.data && result.data.larvae_required === true;
          this.form.created_at = this.form.created_at.slice(0, -5);
          this.pests = result.test_result;
          
          this.mlReliability = result.ml_reliability || null;

          this.syncLarvaeFromResults(result.test_result);
          this.syncPetDetectionFromResults(result.test_result);
          this.syncCoccidiaPresentUncountedFromResults(result.test_result);

          // Parse and normalise reviewer_obs from API          
          this.form.reviewer_obs = this.parseReviewerObs(this.form.reviewer_obs);          
        })
        .catch((err) => {
          this.errMsg = err.messages;
        });
    },

    syncLarvaeFromResults(testResult) {      
      if (!Array.isArray(testResult)) {
        this.larvaeForm.is_positive = false;
        return;
      }

      const larvaePest = testResult.find(
        (p) => (p.pest || "").toLowerCase() === "larvae"
      );

      if (larvaePest && (larvaePest.status === "positive" || larvaePest.status === "negative")) {
        this.larvaeForm.is_positive = larvaePest.status === "positive";
        return;
      }

      this.larvaeForm.is_positive = false;
    },
    syncPetDetectionFromResults(testResult) {
      Object.keys(this.petDetection).forEach((k) => {
        this.petDetection[k] = false;
      });
      Object.keys(this.petInvalid).forEach((k) => {
        this.petInvalid[k] = false;
      });
      if (this.form.test_type != 4 || !Array.isArray(testResult)) {
        return;
      }
      testResult.forEach((p) => {
        const name = p.pest;
        if (Object.prototype.hasOwnProperty.call(this.petDetection, name)) {
          const c = Number(p.pest_count);
          // Detected when pest_count is 1 (0 = Not Detected, -1 = Invalid).
          this.petDetection[name] = c === 1;
          if (Object.prototype.hasOwnProperty.call(this.petInvalid, name)) {
            this.petInvalid[name] = c === -1;
          }
        }
      });
    },
    syncCoccidiaPresentUncountedFromResults(testResult) {
      // Reload the Coccidia "detected but not countable" flag so the checkbox
      // agrees with the saved result (non-pet only; pets never carry it).
      this.isChecked_present_uncounted = false;
      if (this.form.test_type == 4 || !Array.isArray(testResult)) {
        return;
      }
      const coccidia = testResult.find(
        (p) => p.pest === "Coccidia" && p.count_qualifier === "PRESENT_UNCOUNTED"
      );
      if (coccidia) {
        this.isChecked_present_uncounted = true;
      }
    },
    UpdateTest() {
      // Update reviewer name automatically
      this.Addreviewer();
      
      // Clear previous messages and start modal loading
      this.msg = [];
      this.errMsg = [];
      this.modalLoading = true;
      
      
      this.store
        .dispatch("Admin/UpdateTestInfo", {
          id: this.$route.params.id,
          body: { ...this.form, notify: this.notify },
        })
        .then((result) => {
          this.modalLoading = false;
          this.msg = result.messages;
        })
        .catch((err) => {
          this.modalLoading = false;
          this.errMsg = err.messages;
          this.msg = "";
          if(!this.errMsg || this.errMsg.length == 0){
            this.errMsg = ["An error occurred while updating the test, please try again."];
          }          
        });
    },
    Addreviewer(){
      const value = this.getReviewedByValue();
      this.form.reviewed_by = value;
    },
    getReviewedByValue(){
      return this.store.state["User"].info.name;
    },

    normalisePestCountForPayload(value) {
      if (value === "" || value === null || value === undefined) {
        return 0;
      }

      const count = Number(value);
      return Number.isNaN(count) ? 0 : count;
    },

    gatherPestResults() {
      const pestsToInclude = [];
      const pestCounts = {
        "Coccidia": this.normalisePestCountForPayload(this.pestForm.Count_Coccidia),
        "Strongyle": this.normalisePestCountForPayload(this.pestForm.Count_Strongyle),
        "Nematodirus battus": this.normalisePestCountForPayload(this.pestForm.Count_Nematodirus_Battus),
        "Nematodirus spp": this.normalisePestCountForPayload(this.pestForm.Count_Nematodirus_Spp),
        "Strongyloides": this.normalisePestCountForPayload(this.pestForm.Count_Strongyloides),
        "Moniezia": this.normalisePestCountForPayload(this.pestForm.Count_Moniezia),
        "Trichuris": this.normalisePestCountForPayload(this.pestForm.Count_Trichuris),
        "Anoplocephala": this.normalisePestCountForPayload(this.pestForm.Count_Anoplocephala),
        "Parascaris": this.normalisePestCountForPayload(this.pestForm.Count_Parascaris),
        "Liver Fluke": this.normalisePestCountForPayload(this.pestForm.Count_LiverFluke),
        "Rumen Fluke": this.normalisePestCountForPayload(this.pestForm.Count_RumenFluke),
        "Roundworm": this.normalisePestCountForPayload(this.pestForm.Count_Roundworm),
        "Whipworm": this.normalisePestCountForPayload(this.pestForm.Count_Whipworm),
        "Hookworm": this.normalisePestCountForPayload(this.pestForm.Count_Hookworm),
        "Tracheal Worm": this.normalisePestCountForPayload(this.pestForm.Count_Tracheal_Worm),
        "Ascaridia": this.normalisePestCountForPayload(this.pestForm.Count_Ascaridia),
        "Capillaria": this.normalisePestCountForPayload(this.pestForm.Count_Capillaria),
        "Syngamus": this.normalisePestCountForPayload(this.pestForm.Count_Syngamus),
        "Tapeworm": this.normalisePestCountForPayload(this.pestForm.Count_Tapeworm),
        "E. Macusaniensis": this.normalisePestCountForPayload(this.pestForm.Count_Eimeria_Macusaniensis),
        "E. Ivitaensis": this.normalisePestCountForPayload(this.pestForm.Count_Eimeria_Ivitaensis),
        "Marshalaga": this.normalisePestCountForPayload(this.pestForm.Count_Marshalaga),
      };

      // Determine pests based on animaltype and test_type
      let pestsNeeded = [];
      // Equine && not Fluke && not Companion Animal
      if (this.form.animaltype == 3 && this.form.test_type != 3 && this.form.test_type != 4) {
        pestsNeeded = ["Coccidia", "Strongyle", "Parascaris", "Strongyloides", "Anoplocephala"];
      }
      // (Bovine OR Ovine OR Caprine) && not Fluke && not Companion Animal
      else if ([1,2,4].includes(this.form.animaltype) && this.form.test_type != 3 && this.form.test_type != 4) {
        pestsNeeded = ["Coccidia", "Strongyle", "Nematodirus battus", "Nematodirus spp", "Strongyloides", "Moniezia", "Trichuris"];
      }
      // (Bovine OR Ovine OR Caprine OR Alpaca OR Llama) && Fluke
      else if ([1,2,4,8,9].includes(this.form.animaltype) && this.form.test_type == 3) {
        pestsNeeded = ["Liver Fluke", "Rumen Fluke"];
      }
      // Equine && Fluke
      else if (this.form.animaltype == 3 && this.form.test_type == 3) {
        pestsNeeded = ["Liver Fluke"];
      }
      // (Canine OR Feline) && Companion Animal
      else if ([5,6].includes(this.form.animaltype) && this.form.test_type == 4) {
        pestsNeeded = ["Roundworm", "Whipworm", "Hookworm", "Tapeworm", "Capillaria", "Coccidia"];
      }
      // Poultry && WORM FEC
      else if (this.form.animaltype == 7 && this.form.test_type == 1) {
        pestsNeeded = ["Coccidia", "Ascaridia", "Capillaria", "Syngamus", "Tapeworm", "Strongyle"];
      }
      // Alpaca OR Llama && WORM FEC
      else if ([8,9].includes(this.form.animaltype) && this.form.test_type != 3) {
        pestsNeeded = ["Coccidia", "E. Macusaniensis", "E. Ivitaensis", "Capillaria", "Trichuris", "Marshalaga", "Nematodirus battus", "Nematodirus spp", "Strongyle", "Strongyloides", "Moniezia"];
      }      

      pestsNeeded.forEach(pest => {
        // Pet tests (test_type 4) are detection-only: Status carries the answer
        // and Count is a sentinel (-2 = detection result, not an egg count).
        if (this.form.test_type == 4) {
          // Pet detection travels on pest_count as a nominal value:
          // 1 = Detected, 0 = Not Detected (-1 = Invalid). Never -2 (that means
          // "pending/analysing" on the backend). Status is kept consistent.
          const invalid = this.petInvalid[pest] === true;
          const detected = this.petDetection[pest];
          pestsToInclude.push({
            Type: pest,
            Count: invalid ? -1 : (detected ? 1 : 0),
            Status: (!invalid && detected) ? "positive" : "negative",
          });
          return;
        }
        // Coccidia detected-but-not-countable (non-pet only). Canonical stored
        // shape per the backend handoff: positive, Count -1, qualifier set.
        // Mutually exclusive with count/Invalid, so it takes precedence here.
        if (pest === "Coccidia" && this.isChecked_present_uncounted) {
          pestsToInclude.push({
            Type: "Coccidia",
            Count: -1,
            Status: "positive",
            CountQualifier: "PRESENT_UNCOUNTED",
          });
          return;
        }
        const count = pestCounts[pest];
        pestsToInclude.push({
          Type: pest.toLowerCase() === "nematodirus spp" ? "Nematodirus" : pest,
          Count: this.pestForm.Inconclusive ? -1 : count,
          Status: count > 0 ? "positive" : "negative",
        });
      });

      // Optional Larvae result: include if business requires it OR if larvae was previously saved — non-Fluke only
      // Pets (test_type 4) never have larvae — never include a larvae result for them.
      if ((this.form.larvae_required === true || this.hasLarvaeData) && this.form.test_type != 3 && this.form.test_type != 4) {
        pestsToInclude.push({
          Type: "Larvae",
          Count: -3,
          Status: this.larvaeForm.is_positive ? "positive" : "negative",
        });
      }

      return pestsToInclude;
    },

    AddResult_full(forceOverride = false) {
      if (this.form.status != "failed") {
        this.msg = [];
        this.errMsg = [];
        this.loading = true;

        const pestResults = this.gatherPestResults();
        
        // Simple request with forceOverride flag for conflict handling
        const requestData = {
          id: this.$route.params.id,
          body: pestResults,
          forceOverride: forceOverride  // Flag to override if results already saved
        };

        // Preserve reviewer_obs before GetData overwrites it
        const savedReviewerObs = [...this.form.reviewer_obs];

        this.store.dispatch("Admin/CreateUpdateTestResult", requestData)
        .then(() => {
          this.loading = false;
          this.msg = ["Successfully updated test results."];
          
          // Refresh data but preserve reviewer_obs
          this.GetData().then(() => {
            this.form.reviewer_obs = savedReviewerObs;            
          });
          
          this.OpenSaveChanges();
        })
        .catch((err) => {
          this.loading = false;
          
          // Check if this is a conflict error (HTTP 409)
          if (err.status === 409 || err.error === 'CONFLICT') {
            this.conflictDetails = err.conflictDetails || {
              lastUpdatedBy: err.lastUpdatedBy,
              lastUpdatedAt: err.lastUpdatedAt
            };
            this.showConflictModal = true;
            return;
          }
          
          // Handle other errors normally
          console.error(err);
          this.errMsg = err.messages || ["An error occurred while saving results, please try again."];
          this.msg = [];
          this.scrollToTop();
        });
      } else {
        this.OpenSaveChanges();
      }
    },    

    
    handleCheckboxChange() {      
      this.handleCopyMLResults(this.isChecked);
    },
    handleCheckboxinconclusive(){
      // Handle Coccidia Invalid checkbox
      if(this.isChecked_inconclusive){
        // Invalid and Present (uncounted) are mutually exclusive.
        this.isChecked_present_uncounted = false;
        // When checked, set to -1 (Invalid)
        this.pestForm.Count_Coccidia = -1;
      } else {
        // When unchecked, return to the untouched placeholder state.
        this.pestForm.Count_Coccidia = "";
      }
      
      // Handle Strongyloides Invalid checkbox
      if(this.isChecked_inconclusive_strongyloides){
        // When checked, set to -1 (Invalid)
        this.pestForm.Count_Strongyloides = -1;
      } else {
        // When unchecked, return to the untouched placeholder state.
        this.pestForm.Count_Strongyloides = "";
      }
    },
    handleCheckboxPresentUncounted(){
      // Coccidia "detected but not countable" (non-pet only). When ticked it is
      // mutually exclusive with the count input and the Invalid checkbox.
      if(this.isChecked_present_uncounted){
        this.isChecked_inconclusive = false;
        this.pestForm.Count_Coccidia = "";
      }
    },
    
    handleCopyMLResults(checked) {
      if (checked) {
        this.performMLCopy();
      } else {
        // Restore previous pestForm state
        this.restorePreviousState();
      }
    },
    
    performMLCopy() {
      // Save current pestForm state and Invalid checkbox states for restoration
      this.savedReviewerState = {
          Count_Coccidia: this.pestForm.Count_Coccidia,
          Count_Strongyle: this.pestForm.Count_Strongyle,
          Count_Nematodirus_Battus: this.pestForm.Count_Nematodirus_Battus,
          Count_Nematodirus_Spp: this.pestForm.Count_Nematodirus_Spp,
          Count_Strongyloides: this.pestForm.Count_Strongyloides,
          Count_Moniezia: this.pestForm.Count_Moniezia,
          Count_Anoplocephala: this.pestForm.Count_Anoplocephala,
          Count_Parascaris: this.pestForm.Count_Parascaris,
          Count_Trichuris: this.pestForm.Count_Trichuris,
          Count_LiverFluke: this.pestForm.Count_LiverFluke,
          Count_RumenFluke: this.pestForm.Count_RumenFluke,
          Count_Roundworm: this.pestForm.Count_Roundworm,
          Count_Whipworm: this.pestForm.Count_Whipworm,
          Count_Hookworm: this.pestForm.Count_Hookworm,
          Count_Tracheal_Worm: this.pestForm.Count_Tracheal_Worm,
          Count_Ascaridia: this.pestForm.Count_Ascaridia,
          Count_Capillaria: this.pestForm.Count_Capillaria,
          Count_Syngamus: this.pestForm.Count_Syngamus,
          Count_Tapeworm: this.pestForm.Count_Tapeworm,
          Count_Eimeria_Macusaniensis: this.pestForm.Count_Eimeria_Macusaniensis,
          Count_Eimeria_Ivitaensis: this.pestForm.Count_Eimeria_Ivitaensis,
          Count_Marshalaga: this.pestForm.Count_Marshalaga,
          isChecked_inconclusive: this.isChecked_inconclusive,
          isChecked_inconclusive_strongyloides: this.isChecked_inconclusive_strongyloides,
          isChecked_present_uncounted: this.isChecked_present_uncounted
        };
        
        // Copy ML results (original_count) to Reviewer Input (pestForm)
        this.pests.forEach(pest => {
          // Copy the ML result (original_count) verbatim into the reviewer input.
          const countToCopy = pest.original_count;
          
          // Map pest names to pestForm fields
          if (pest.pest === "Coccidia") {
            this.pestForm.Count_Coccidia = countToCopy;
            this.isChecked_inconclusive = false; // Uncheck Invalid
            this.isChecked_present_uncounted = false; // Uncheck Present (uncounted)
          }
          if (pest.pest === "Strongyle") {
            this.pestForm.Count_Strongyle = countToCopy;
          }
          if (pest.pest === "Nematodirus battus") {
            this.pestForm.Count_Nematodirus_Battus = countToCopy;
          }
          if (pest.pest === "Nematodirus" || pest.pest === "Nematodirus spp") {
            this.pestForm.Count_Nematodirus_Spp = countToCopy;
          }
          if (pest.pest === "Strongyloides") {
            this.pestForm.Count_Strongyloides = countToCopy;
            this.isChecked_inconclusive_strongyloides = false; // Uncheck Invalid
          }
          if (pest.pest === "Moniezia") {
            this.pestForm.Count_Moniezia = countToCopy;
          }
          if (pest.pest === "Anoplocephala") {
            this.pestForm.Count_Anoplocephala = countToCopy;
          }
          if (pest.pest === "Parascaris") {
            this.pestForm.Count_Parascaris = countToCopy;
          }
          if (pest.pest === "Trichuris") {
            this.pestForm.Count_Trichuris = countToCopy;
          }
          if (pest.pest === "Liver Fluke") {
            this.pestForm.Count_LiverFluke = countToCopy;
          }
          if (pest.pest === "Rumen Fluke") {
            this.pestForm.Count_RumenFluke = countToCopy;
          }
          if (pest.pest === "Roundworm") {
            this.pestForm.Count_Roundworm = countToCopy;
          }
          if (pest.pest === "Whipworm") {
            this.pestForm.Count_Whipworm = countToCopy;
          }
          if (pest.pest === "Hookworm") {
            this.pestForm.Count_Hookworm = countToCopy;
          }
          if (pest.pest === "Tracheal Worm") {
            this.pestForm.Count_Tracheal_Worm = countToCopy;
          }
          if (pest.pest === "Ascaridia") {
            this.pestForm.Count_Ascaridia = countToCopy;
          }
          if (pest.pest === "Capillaria") {
            this.pestForm.Count_Capillaria = countToCopy;
          }
          if (pest.pest === "Syngamus") {
            this.pestForm.Count_Syngamus = countToCopy;
          }
          if (pest.pest === "Tapeworm") {
            this.pestForm.Count_Tapeworm = countToCopy;
          }
          if (pest.pest === "E. Macusaniensis") {
            this.pestForm.Count_Eimeria_Macusaniensis = countToCopy;
          }
          if (pest.pest === "E. Ivitaensis") {
            this.pestForm.Count_Eimeria_Ivitaensis = countToCopy;
          }
          if (pest.pest === "Marshalaga") {
            this.pestForm.Count_Marshalaga = countToCopy;
          }
        });
    },
    
    restorePreviousState() {
      // Restore previous pestForm state
      if (this.savedReviewerState) {
          this.pestForm.Count_Coccidia = this.savedReviewerState.Count_Coccidia;
          this.pestForm.Count_Strongyle = this.savedReviewerState.Count_Strongyle;
          this.pestForm.Count_Nematodirus_Battus = this.savedReviewerState.Count_Nematodirus_Battus;
          this.pestForm.Count_Nematodirus_Spp = this.savedReviewerState.Count_Nematodirus_Spp;
          this.pestForm.Count_Strongyloides = this.savedReviewerState.Count_Strongyloides;
          this.pestForm.Count_Moniezia = this.savedReviewerState.Count_Moniezia;
          this.pestForm.Count_Anoplocephala = this.savedReviewerState.Count_Anoplocephala;
          this.pestForm.Count_Parascaris = this.savedReviewerState.Count_Parascaris;
          this.pestForm.Count_Trichuris = this.savedReviewerState.Count_Trichuris;
          this.pestForm.Count_LiverFluke = this.savedReviewerState.Count_LiverFluke;
          this.pestForm.Count_RumenFluke = this.savedReviewerState.Count_RumenFluke;
          this.pestForm.Count_Roundworm = this.savedReviewerState.Count_Roundworm;
          this.pestForm.Count_Whipworm = this.savedReviewerState.Count_Whipworm;
          this.pestForm.Count_Hookworm = this.savedReviewerState.Count_Hookworm;
          this.pestForm.Count_Tracheal_Worm = this.savedReviewerState.Count_Tracheal_Worm;
          this.pestForm.Count_Ascaridia = this.savedReviewerState.Count_Ascaridia;
          this.pestForm.Count_Capillaria = this.savedReviewerState.Count_Capillaria;
          this.pestForm.Count_Syngamus = this.savedReviewerState.Count_Syngamus;
          this.pestForm.Count_Tapeworm = this.savedReviewerState.Count_Tapeworm;
          this.pestForm.Count_Eimeria_Macusaniensis = this.savedReviewerState.Count_Eimeria_Macusaniensis;
          this.pestForm.Count_Eimeria_Ivitaensis = this.savedReviewerState.Count_Eimeria_Ivitaensis;
          this.pestForm.Count_Marshalaga = this.savedReviewerState.Count_Marshalaga;
          this.isChecked_inconclusive = this.savedReviewerState.isChecked_inconclusive;
          this.isChecked_inconclusive_strongyloides = this.savedReviewerState.isChecked_inconclusive_strongyloides;
          this.isChecked_present_uncounted = this.savedReviewerState.isChecked_present_uncounted;

          this.savedReviewerState = null;
        }
    },
    
    DeleteResult(pestid, index) {
      this.store
        .dispatch("Admin/DeleteTestResult", {
          test_id: this.$route.params.id,
          result_id: pestid,
        })
        .then((result) => {
          this.pests.splice(index, 1);
          this.msg = result.messages;
          this.GetData();
        })
        .catch((err) => {
          this.errMsg = err.messages;
        });
    },
    TimeParse(time) {
      let date = new Date(time);
      let returntime = `${("0" + date.getDate()).slice(-2)}/${(
        "0" +
        (date.getMonth() + 1)
      ).slice(-2)}/${date.getFullYear()} ${("0" + date.getHours()).slice(
        -2
      )}:${("0" + date.getMinutes()).slice(-2)}`;

      return returntime;
    },
    TimeToResults() {
      if (this.form.created_at && this.form.reviewed_at) {
        let time1 = this.form.created_at.split(".");
        time1 = new Date(time1[0]);
        let time2 = this.form.reviewed_at.split(".");
        time2 = new Date(time2[0]);
        const hours = parseInt(
          Math.abs(time2.getTime() - time1.getTime()) / (1000 * 60 * 60)
        );
        const minutes = parseInt(
          (Math.abs(time2.getTime() - time1.getTime()) / (1000 * 60)) % 60
        );
        const seconds = parseInt(
          (Math.abs(time2.getTime() - time1.getTime()) / 1000) % 60
        );
        // The same figures either way. What changes is the claim about who
        // spent them: on an automatic release the interval is the machine's
        // turnaround from upload to result, and no person spent any of it.
        return this.form.auto_saved
          ? `Automatic release time: ${hours} hours, ${minutes} minutes & ${seconds} seconds.`
          : `Manual reviewed time: ${hours} hours, ${minutes} minutes & ${seconds} seconds.`;
      } else if (this.form.created_at && this.pests !== "" && this.pests.length > 0) {
        return "Test results are available.";
      } else {
        return "No results available yet.";
      }
    },

    DownloadVideo(url, uri) {
      axios
        .get(`${url}/${uri}`, {
          responseType: "blob",
          headers: {
            Authorization: "",
          },
        })
        .then(({ data }) => {
          saveAs(data, uri);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    OpenSaveChanges() {
     
      // Get the modal
      var modal = document.getElementById("savechanges-modal");

      // Get the <span> element that closes the modal
      var span = document.getElementsByClassName("close")[0];

      // When the user clicks on the button, open the modal
      modal.style.display = "block";

      // When the user clicks on <span> (x), close the modal
      span.onclick = function () {
        modal.style.display = "none";
      };

      // When the user clicks anywhere outside of the modal, close it
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      };
    },
    downloadFEC() {
      this.store
        .dispatch("Admin/DownloadFEC", { id: this.$route.params.id })
        .then((result) => {
          // Begin PDF
          html2pdf(result.html, {
            margin: [0, 8, 15, 0],
            filename: this.form.cow_id + " - FEC.pdf",
            type: "jpeg",
            quality: 100,
            html2canvas: { dpi: 900, letterRendering: true, scale: 3 },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          });
        })
        .catch((err) => {
          this.errMsg = err.messages;
          console.log(err.messages);
        });
    },
    confirmConflictOverride() {
      // User confirmed they want to override the previous changes
      this.showConflictModal = false;
      this.conflictDetails = null;
      
      // Retry save with force flag
      this.AddResult_full(true);
    },
    cancelConflictOverride() {      
      this.showConflictModal = false;
      this.conflictDetails = null;
      this.pendingSaveData = null;
      this.loading = false;            
      this.GetData();
      this.msg = ["Save cancelled. The page has been refreshed with the latest data."];
      this.scrollToTop();
    },
    formatConflictTime(timestamp) {
      if (!timestamp) return 'Unknown';
      
      try {
        const date = new Date(timestamp);
        return date.toLocaleString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      } catch (e) {
        return timestamp;
      }
    },
    setFailReason() {
      if(this.form.failreasons_drop.includes("A large air bubble is present in the slide.")){
        this.form.failreason = "A large air bubble is present in the slide.\n\nComments: Please ensure the slide is filled fully for accurate analysis. Elevating one end of the slide can help with avoiding air bubbles when filling the slide. Please contact customer support if you have any questions. The credit has been refunded."
      }
      if(this.form.failreasons_drop.includes("Too many small air bubbles.")){
        this.form.failreason = "Too many small air bubbles.\n\nComments: Once saline is added to the sample, make sure not to shake the sample to avoid air bubbles. Instead gently invert the vial or flick the end of the vial to mix the sample. Please contact customer support if you have any questions.The credit has been refunded."
      }
      if(this.form.failreasons_drop.includes("Water on the slide.")){
        this.form.failreason = "Water on the slide.\n\nComments: Please dry off the slide thoroughly ensuring it is fully dried before inserting into the reader. Please contact customer support if you have any questions. The credit has been refunded."
      }
      if(this.form.failreasons_drop.includes("The full slide was not captured.")){
        this.form.failreason = "The full slide was not captured.\n\nComments: The start/end of your slide was not recorded. Due to the missing data an accurate analysis cannot be done. Please try again making sure the 'L' symbol is visible at the start and end of the test. Please contact customer support if you have any questions. The credit has been refunded."
      }
      if(this.form.failreasons_drop.includes("The full Fluke slide was not captured.")){
        this.form.failreason = "The full slide was not captured.\n\nComments: The start/end of your slide was not recorded. Due to the missing data an accurate analysis cannot be done. Please try again making sure the '=' symbol is visible at the start and end of the test. Please contact customer support if you have any questions. The credit has been refunded."
      }
      if(this.form.failreasons_drop.includes("No image was detected.")){
        this.form.failreason = "No image was detected.\n\nComments: Your phone may need to be re-adjusted on the phone attachment. Please make sure a full, clear round microscopic image is visible before beginning your test. Please contact customer support if you have any questions. The credit has been refunded."
      }
      if(this.form.failreasons_drop.includes("Incorrect phone alignment.")){
        this.form.failreason = "Incorrect phone alignment.\n\nComments: This can affect the image quality and prevent the full testing area from being visible for accurate analysis. Please ensure the full circle of the microscopic image is visible to allow for accurate analysis of the sample. Please contact customer support if you have any questions. The credit has been refunded."
      }
      if(this.form.failreasons_drop.includes("The sample is too dark for accurate processing affecting egg visibility.")){
        this.form.failreason = "The sample is too dark for accurate processing affecting egg visibility.\n\nComments: Please allow the slide to rest for 10 minutes before trying again. If the sample is still very dark, please contact customer support. Your credit has been refunded."
      }
      if(this.form.failreasons_drop.includes("Poor focus affecting visibility.")){
        this.form.failreason = "Poor focus affecting visibility.\n\nComments: Please clean all lenses. To clean the internal lens inside the reader please use a long cotton swab and then try again. If this issue persists, please contact customer support. Your credit has been refunded."
      }
      if(this.form.failreasons_drop.includes("Technical issue.")){
        this.form.failreason = "Technical issue.\n\nComments: Please contact customer support if you have any questions. The credit has been refunded."
      }
      
    },

  },
  mounted() {
    this.GetData();
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    

  },
  beforeUnmount() {
    // Remove the event listener when the component is destroyed
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
   
  },
  watch: {
    form() {
      this.playerOptions.sources = [
        {
          type: "video/mp4",
          src: `https://video.stage.micronagritech.com/${encodeURIComponent(
            this.form.bucket_file
          )}`,
        },
      ];
      this.playerOptions_dect.sources = [
        {
          type: "video/mp4",
          src: `https://detected-videos.s3.eu-west-1.amazonaws.com/${encodeURIComponent(
            this.form.detected_bucket_file
          )}`,
        },
      ];
    }
    ,
    pests() {
      this.TimeToResults();
    },
  },
};


</script>

<style>
/* Reviewer flag column: Invalid / Present (uncounted) toggles */
.reviewer-flag-option {
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  font-size: 14px;
  line-height: 1.4;
}

/* Global styles */
html, body {
  height: 100%;
  min-height: 100%;
  position: relative;
}

/* Main container styles */
.admin-tests-modify-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

/* The same icon the queue uses, so both screens teach one thing once. It sits
   between the label and the field, reading as "Reviewed By: [machine] Video
   Sentinel (automatic)". */
.reviewed-by-ml {
  width: 35px;
  height: auto;
  vertical-align: middle;
  margin: 0 6px 0 2px;
}

/* Spinner styles */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999; /* Higher than modal's z-index: 99999 */
}
.spinner {
  border: 8px solid rgba(4, 163, 148, 0.1);
  border-top: 8px solid #04a394;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.error {
  height: auto;
  width: 100%;
  background: #e34343;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  display: block;
  border-radius: 10px;
  font-size: 17px;
  color: #fff;
  border: 1px solid #c52f2f;
  margin-bottom: 5px;
}

.success {
  height: auto;
  width: 100%;
  background: #04a394;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  display: block;
  border-radius: 10px;
  font-size: 17px;
  color: #fff;
  border: 1px solid #069486;
  margin-bottom: 5px;
}

table .input {
  height: 30px;
  width: 100%;
  font-size: 17px;
  color: #4d4d4d !important;
  text-align: center;
  display: block;
  background: #fff !important;
  outline: 0;
  border: 1px solid #c8ced5;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 1px;
  box-sizing: border-box;
}

.modal {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 99999;
  /* Sit on top */
  padding-top: 100px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 50%;
  border-radius: 10px;
  max-height: 90vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

/* Special Attention frame: decoration lives on a wrapper so the table keeps its
   normal collapsed borders (border-radius needs a wrapper; it can't apply to a
   border-collapse: collapse table). overflow: hidden clips the square table
   corners to the rounded frame. */
/* Shrink-to-fit group around the table and its flag indicator. The table renders
   display:block (for horizontal scroll) and shrink-wraps its columns to content
   width; fit-content makes this group hug the actual table so the frame doesn't
   stretch to a large empty area on wide screens, and the flag indicator below can
   be pinned to the same width. max-width keeps it within the viewport (the table
   scrolls internally when narrower). */
.table-flag-group {
  width: fit-content;
  max-width: 100%;
}

.special-attention-frame {
  border: 1px solid #f47c2e;
  border-radius: 8px;
  box-shadow: 0 0 16px rgba(244, 124, 46, 0.5);
  overflow: hidden;
}

/* Double Check's bar sits on the table so that, with Special Attention, it shows
   inside the orange frame on the wrapper. */
table.double-check {
  border-left: 5px solid #7a2650;
}

/* Egg thumbnail */
.egg-tooltip-container {
  position: relative;
  display: inline-block;
}

.egg-tooltip-content {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 2px;
  background: rgba(255, 255, 255, 1); /* <-- white with slight transparency */
  padding: 5px;
  z-index: 999;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 6px 6px rgba(0, 0, 0, 0.15);
}

.egg-tooltip-container:hover .egg-tooltip-content,
.egg-tooltip-row.tooltip-visible .egg-tooltip-content {
  display: block;
}

.egg-thumbnail {
  width: auto;
  max-width: 60px;
  height: 80px;
  object-fit: contain;
  display: block;
}

/* Dual-image tooltip (e.g. Ascaridia) */
.egg-tooltip-container:hover .egg-tooltip-content.egg-tooltip-dual,
.egg-tooltip-row.tooltip-visible .egg-tooltip-content.egg-tooltip-dual {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
}

.egg-tooltip-dual-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.egg-tooltip-label {
  font-size: 10px;
  color: #555;
  margin-top: 4px;
  font-style: italic;
  text-align: center;
  white-space: nowrap;
}

/* Disabled button styling */
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Conflict Warning Modal Styles */
.conflict-modal {
  max-width: 600px;
}

.conflict-warning-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f59e0b;
}

.conflict-warning-header h3 {
  margin: 0;
  color: #d97706;
  font-size: 20px;
}

.conflict-message {
  margin-bottom: 20px;
}

.conflict-lead {
  font-size: 15px;
  margin-bottom: 15px;
  color: #1f2937;
}

.conflict-detail {
  background: #fef3c7;
  border: 1px solid #fde68a;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 15px;
}

.conflict-info-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
}

.conflict-label {
  font-weight: 600;
  color: #92400e;
}

.conflict-value {
  color: #78350f;
  font-weight: 500;
}

.conflict-warning-box {
  background: #fee2e2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 12px;
  margin: 15px 0;
}

.conflict-warning-box p {
  margin: 5px 0;
  color: #991b1b;
  font-size: 14px;
}

.conflict-warning-box-unknown {
  background: #fef3c7;
  border: 1px solid #fde68a;
}

.conflict-warning-box-unknown p {
  color: #92400e;
}

.conflict-warning-box-unknown p strong {
  color: #78350f;
}

.conflict-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e5e7eb;
}

.conflict-actions .btn {
  min-width: 140px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-danger {
  background-color: #dc2626;
  color: white;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.3);
}

.btn-danger:hover {
  background-color: #b91c1c;
  box-shadow: 0 4px 8px rgba(220, 38, 38, 0.4);
  transform: translateY(-1px);
}

.btn-danger:active {
  background-color: #991b1b;
  transform: translateY(0);
}

.conflict-actions .btn-green {
  background-color: #04a394;
  color: white;
  box-shadow: 0 2px 4px rgba(4, 163, 148, 0.3);
}

.conflict-actions .btn-green:hover {
  background-color: #038c7e;
  box-shadow: 0 4px 8px rgba(4, 163, 148, 0.4);
  transform: translateY(-1px);
}

.conflict-actions .btn-green:active {
  background-color: #027368;
  transform: translateY(0);
}

.placeholder  {
  position: relative;
}

/* Flag Indicator Base Styles */
.flag-indicator {
  /* Grid rather than flex so the findings list can span both columns and start
     at the icon's left edge, rather than being indented under the title. */
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 8px;
  margin: 16px 0;
  border: 1px solid;
  animation: fadeIn 0.5s ease-in;
  /* Match the table width (set by .table-flag-group) and wrap the message inside
     it. width:0 keeps this element from widening the shrink-to-fit group, while
     min-width:100% stretches it to the group's (table's) width. */
  width: 0;
  min-width: 100%;
  box-sizing: border-box;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.flag-indicator__icon {
  font-size: 24px;
  line-height: 1;
  flex-shrink: 0;
}

.flag-indicator__icon img {
  display: block;
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.flag-indicator__content {
  flex: 1;
}

.flag-indicator__title {
  margin: 0 0 6px 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
}

.flag-indicator__message {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

/* Warning Variant */
.flag-indicator--warning {
  background-color: #FEF3C7;
  border-color: #dbbe8c;
}

.flag-indicator--warning .flag-indicator__title {
  color: #92400E;
}

.flag-indicator--warning .flag-indicator__message {
  color: #78350f;
}

/* Reject Variant.
   Amber, matching the queue badge that brought the reviewer here. A flagged
   check says the video is worth a closer look; whether the counts can be read
   is what the reviewer is here to decide. Red on this screen is kept for a
   decision already taken. */
.flag-indicator--reject {
  background-color: #FDF3E3;
  border-color: #ECCFA2;
}

.flag-indicator--reject .flag-indicator__title {
  color: #C2410C;
}

.flag-indicator--reject .flag-indicator__message {
  color: #78350F;
}

/* Acceptable Variant */
.flag-indicator--acceptable {
  background-color: #DBEAFE;
  border-color: #60A5FA;
}

.flag-indicator--acceptable .flag-indicator__title {
  color: #1E40AF;
}

.flag-indicator--acceptable .flag-indicator__message {
  color: #1E3A8A;
}

/* Pending Variant. Deliberately colourless: the other three report something
   the pipeline found, this one reports that there is nothing to report yet. */
.flag-indicator--pending {
  background-color: #F3F4F6;
  border-color: #9CA3AF;
}

.flag-indicator--pending .flag-indicator__title {
  color: #374151;
}

.flag-indicator--pending .flag-indicator__message {
  color: #4B5563;
}

/* Findings list, shown in place of a message when checks did not pass.
   Spans both grid columns so it lines up with the icon rather than sitting
   indented under the title. */
.flag-indicator__findings {
  grid-column: 1 / -1;
  list-style: none;
  margin: 4px 0 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
}

.flag-indicator__finding {
  padding-left: 10px;
  border-left: 2px solid #C2410C;
  font-size: 14px;
  line-height: 1.45;
  color: #78350F;
}

/* The stage the check came from. Provenance, not priority: it says what kind
   of problem this is without ranking it against the others. Inline rather than
   on its own line, so a finding costs one line instead of two and the banner
   does not rival the counts table it sits under. */
.flag-indicator__finding-stage {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #C2410C;
  opacity: 0.7;
}

.flag-indicator__finding-stage::after {
  content: " · ";
  letter-spacing: 0;
}

/* The checks that could not run at all, gathered into one line. Quieter than
   the findings above it: those say something was wrong, this says something is
   unknown. Every one of them is still named. */
.flag-indicator__unrun {
  grid-column: 1 / -1;
  margin: 8px 0 0 0;
  padding-left: 12px;
  font-size: 13px;
  line-height: 1.45;
  color: #9a5a52;
  text-align: left;
}

.flag-indicator__finding-name {
  font-weight: 600;
}

/* A colon, not a dash. The middot above already joins the stage to the check,
   and repeating it would flatten a line that has two joins doing different
   work: which check, then what it found. */
.flag-indicator__finding-name::after {
  content: ": ";
}

/* Copy ML Section */
.copy-ml-section {
  margin: 16px 0;
  padding: 12px;
  background-color: #F9FAFB;
  border-radius: 6px;
  border: 1px solid #E5E7EB;
}

.copy-ml-section label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 15px;
  color: #374151;
  user-select: none;
}

.copy-ml-section input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

/* Reviewer Observations Styles */
.reviewer-obs-clear-container {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 6px;
  margin-top: 10px;
}

.btn-link-clear {
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 2px 5px;
  border-radius: 6px;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
}

.btn-link-clear:hover {
  background-color: #e2e8f0;
  border-color: #94a3b8;
  color: #334155;
}

.btn-link-clear:active {
  background-color: #cbd5e1;
  transform: translateY(1px);
}

/* Layout container for select and display */
.reviewer-obs-layout {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  margin-top: 10px;
}

.reviewer-obs-select {
  flex: 0 0 auto;
  min-width: 300px;
}

/* Customise focus outline to match slate theme */
.reviewer-obs-select:focus {
  outline: 2px solid #94A3B8;
  outline-offset: 2px;
  border-color: #64748B;
}

/* Customise selected options background to match slate theme */
.reviewer-obs-select option:checked {
  background: #CBD5E1 !important;
  background-color: #CBD5E1 !important;
  color: #1E293B !important;
}

/* Firefox-specific styling */
.reviewer-obs-select option:checked {
  background: linear-gradient(#CBD5E1, #CBD5E1);
}

/* Webkit browsers (Chrome, Safari) */
.reviewer-obs-select option:checked {
  box-shadow: 0 0 10px 100px #CBD5E1 inset;
}

.reviewer-obs-display-wrapper {
  flex: 1;
  min-width: 0;
}

.reviewer-obs-display {
  margin-top: 0;
  padding: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  height: 100%;  
}



.reviewer-obs-empty {
  margin-top: 0;
  padding: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.obs-badges-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.obs-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: #E5EAF0;
  color: #334155;
  border: 1px solid #CBD5E1;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  transition: all 0.2s ease;
  cursor: pointer;
  user-select: none;
}

.obs-badge:hover {
  background: #D1D9E6;
  border-color: #94A3B8;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.obs-badge:active {
  transform: translateY(0);
  box-shadow: none;
}

.badge-remove-icon {
  margin-left: 4px;
  font-size: 11px;
  opacity: 0.5;
  transition: opacity 0.2s ease;
}

.obs-badge:hover .badge-remove-icon {
  opacity: 1;
}

.obs-badge-legacy {
  background: #EFF2F6;
  color: #334155;
  border: 1px dashed #CBD5E1;
}

.obs-badge .legacy-icon {
  font-size: 14px;
  line-height: 1;
}

/* Larvae Badge */
.larvae-badge {
  display: inline-block;
  margin-left: 6px;
  background: linear-gradient(135deg, #0EA5E9 0%, #38BDF8 100%);
  color: #ffffff;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(14, 165, 233, 0.3);
}

/* Larvae Not Analysed State */
.larvae-not-analysed {
  color: #334155;
  font-size: 14px;
  font-style: italic;
  font-weight: 500;
}

/* Larvae Required Row Indicator */
.larvae-required-row {
  background: linear-gradient(90deg, #E0F2FE 0%, #F0F9FF 100%) !important;
  border-left: 4px solid #0EA5E9 !important;
  position: relative;
}

.larvae-required-row td {
  background: transparent !important;
  font-weight: 500;
}

.larvae-required-row td:first-child::before {  
  margin-right: 6px;
  font-size: 14px;
}

/* Larvae Checkbox Styling */
.larvae-checkbox-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 4px;
}

.larvae-checkbox:hover {
  transform: scale(1.4);
}


/* Desktop: ensure wide tables can scroll horizontally without affecting mobile */
@media (min-width: 769px) {
  .content-wrapper table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
  }

  .content-wrapper table thead {
    display: table-header-group;
  }

  .content-wrapper table tbody {
    display: table-row-group;
  }

  .content-wrapper table th,
  .content-wrapper table td {
    white-space: normal;
  }
}

/* Mobile responsive layout fixes */
@media (max-width: 768px) {
  /* Viewport fixes for mobile browsers */
  html {
    height: -webkit-fill-available;
  }
  
  body {
    min-height: 100vh;
    min-height: -webkit-fill-available;
    position: relative;
    overflow: auto;
    width: 100%;
    height: 100%;
  }

  /* Container structure */
  .admin-tests-modify-container {
    min-height: 100vh;
    min-height: -webkit-fill-available;
    height: 100%;
    overflow: visible;
    display: flex;
    flex-direction: column;
  }
  
  .content-wrapper {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    position: relative;
    padding-bottom: 80px; /* Extra space at bottom for last buttons */
  }
  
  /* Layout fixes */
  .placeholder {
    padding: 10px;
    overflow-x: hidden;
    width: 100%;
    min-height: auto;
  }
  
  .placeholder .row {
    margin: 0;
    flex-direction: column;
    width: 100%;
  }
  
  .placeholder .col-6 {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0;
    margin-bottom: 30px;
    touch-action: pan-y pinch-zoom;
  }
  
  /* Form styling */
  .form {
    padding: 0;
    width: 100%;
  }
  
  .form .input,
  .form select,
  .form textarea {
    font-size: 16px; /* Prevents zoom on iOS */
  }

  /* Badge responsive layout - stack on mobile */
  .form label {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
  }
  
  .form label span[title] {
    margin-left: 0 !important;
    font-size: 9px !important;
    padding: 2px 5px !important;
    flex-shrink: 0;
  }
  
  /* Button styling */
  .btn {
    width: 100%;
    margin-bottom: 10px;
    padding: 12px;
    font-size: 15px;
  }
  
  .btn.btn-orange,
  .btn.btn-green {
    margin-right: 0 !important;
  }
  
  /* Table wrapper for horizontal scroll */
  table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    max-width: 100%;
    width: 100%;
    touch-action: pan-x pan-y;
  }
  
  table thead {
    display: table-header-group;
  }
  
  table tbody {
    display: table-row-group;
  }
  
  table th,
  table td {
    font-size: 14px;
    padding: 10px 10px;
    white-space: normal;
  }
  
  table .input {
    font-size: 14px;
    min-width: 60px;
  }
  

  
  .egg-thumbnail {
    width: 60px;
    height: 60px;
  }
  
  /* Flag indicator mobile responsive */
  .flag-indicator {
    grid-template-columns: 1fr;
    justify-items: center;
    text-align: center;
    padding: 12px;
  }
  
  .flag-indicator__icon {
    font-size: 32px;
  }
  
  .flag-indicator__title {
    font-size: 15px;
  }
  
  .flag-indicator__message {
    font-size: 13px;
  }

  /* Modal responsive styling */
  .modal {
    padding-top: 20px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .modal-content {
    width: 80%;
    padding: 15px;
    max-height: 85vh;
  }

  .conflict-modal {
    max-width: 100%;
  }
  
  .conflict-warning-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .conflict-warning-header h3 {
    font-size: 18px;
  }
  
  .conflict-lead {
    font-size: 14px;
  }
  
  .conflict-info-row {
    flex-direction: column;
    gap: 4px;
  }
  
  .conflict-actions {
    flex-direction: column-reverse;
    gap: 8px;
  }
  
  .conflict-actions .btn {
    min-width: 100%;
    width: 100%;
    padding: 12px 16px;
    font-size: 15px;
  }
  
  /* Stack reviewer observations layout on mobile */
  .reviewer-obs-layout {
    flex-direction: column;
    gap: 12px;
  }
  
  .reviewer-obs-select {
    font-size: 16px;
    padding: 10px;
    min-width: 100%;
    width: 100%;
  }
  
  .reviewer-obs-display-wrapper {    
    width: 100%;
  }
}
</style>
